import React from "react";
import useSWR from "swr";
import { InfoBox } from "./components/info-box";
import { IlustracaoPrancheta } from "./illustration/ilustracao-prancheta";
import { stepStyle } from "./step.css";
import { Button } from "./components/button";
import {
  primaryButton,
  inputVariants,
  btnAdicionarRemoverStyle,
} from "./components/button.css";
import { Space } from "./components/space";
import { Modal, Toaster, useToaster } from "@vagastec/ensemble-core";
import { useHistory } from "react-router-dom";
import { modalStyle } from "./step-3.css";
import { Text } from "@vagastec/ensemble-core";
import { IlustracaoPredio } from "./illustration/ilustracao-predio";
import {
  previewEmpresaStyle,
  previewInfoEmpresaStyle,
  containerInfoLocalStyle,
  containerInfoModeloStyle,
  candidatarCardStyle,
  mapStyle,
  salarioStyle,
  btnFakeCandidatura,
  iconeCompartilharStyle,
  previewTagStyle,
  candidatarSpaceStyle,
  previewEmpresaContentStyle,
  previewMainStyle,
  previewMainContentStyle,
  candidatarContentStyle,
  previewTagListStyle,
  previewLogoStyle,
  infoVagaPublicada,
  formStep4Style,
  rowStyle,
  separatorStyle,
  wrapperIconePcd,
  listBenefits,
  benefitItem,
  benefitItemPreview,
} from "./step-4.css";
import { IconeDolar } from "./icons/Icone-dolar";
import { IconeMapa } from "./icons/Icone-mapa";
import { IconeIdCard } from "./icons/icone-id-card";
import { IconeCompartilhar } from "./icons/icone-compartilhar";
import { IconePcd } from "./icons/icone-pcd";
import { vars } from "./theme.css";
import { IconeRelogio } from "./icons/icone-relogio";
import { FormCard } from "./components/form-card";
import { IconeSpreadSheet } from "./icons/icone-spreadsheet";
import { IconeUserDetail } from "./icons/icone-user-detail";
import { IconeCalender } from "./icons/icone-calender";
import { IconeFile } from "./icons/icone-file";
import { IconesBeneficios } from "./icons/icones-beneficios";
import { LogoEtalent } from "./icons/logo-etalent";
import { IconeEnvelope } from "./icons/icone-envelope";
import { Select } from "./components/select";
import { renderSelectOptions } from "./render-select-options";
import { Label } from "./components/label";
import { Checkbox } from "./components/checkbox";
import { Input } from "./components/input";
import { TextEditor } from "./components/text-editor";
import { IconMinusCircle } from "./icons/icon-minus-circle";
import { IconPlusCircle } from "./icons/icon-plus-circle";
import { selectFichasStyle, wrapperAdicionarRemoverFichas } from "./step-2.css";
import { uid } from "uid/single";
import { dateWrapper, formButtonsWrapper } from "./index.css";
import { Fieldset } from "./components/fieldset";
import { RadioButton } from "./components/radio-button";
import { Switch } from "./components/switch";
import { useDebounce } from "./debounce";
import { fetcherWithToken } from "./fetcher-with-token";
import {
  containerSalario,
  infoIconContainer,
  selectedBenefits,
} from "./step-1.css";
import { Alert } from "./components/alert";
import { InfoIcon } from "./icons/info-icon";
import { useLocation, useParams } from "react-router-dom";
import { EditLock } from "./components/edit-lock";
import { Combobox } from "./components/combobox";
import CreatableSelect from "react-select/creatable";
import { validateEmailWithOptionalUsername } from "./validate-email";
import { getCookie } from "./cookies";
import { FieldsetSobreEmpresa } from "./fieldset-sobre-empresa";
import FormCardLoader from "./components/form-card-loader";
import { Spinner } from "./components/spinner";
import { Tooltip } from "./components/tooltip";
import { wrapperTooltipStyle } from "./components/tooltip.css";
import { extractTextFromHtmlString } from "./extract-text-from-html-string";
import isObject from "lodash/isObject";
import { defineMessage, FormattedMessage, useIntl } from "react-intl";
import { Multi } from "./components/multi";
import { circle, circleVariant, divider, dividerVariant } from "./steps.css";
import { ControlePosicoes } from "./controle-posicoes";
import { Salario } from "./salario";
import { formatString } from "./utils/formatString";

export function Step4({ formState, setFormState, setSelectedStepId }) {
  const [isPostPending, setIsPostPending] = React.useState(false);
  const [isEmailsPostPending, setIsEmailsPostPending] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [hasTriedToSubmit, setHasTriedToSubmit] = React.useState(false);
  const [active, setActive] = React.useState(false);
  const [isEditingDivisao, setIsEditingDivisao] = React.useState(false);
  const [isEditingResponsavel, setIsEditingResponsavel] = React.useState(false);
  const [isEditingSubdivisoes, setIsEditingSubdivisoes] = React.useState(false);
  const [isEditingVagaTeste, setIsEditingVagaTeste] = React.useState(false);
  const [isEditingCanaisDivulgacao, setIsEditingCanaisDivulgacao] =
    React.useState(false);

  const [isEditingIndicacao, setIsEditingIndicacao] = React.useState(false);
  const [isEditingParceiros, setIsEditingParceiros] = React.useState(false);
  const [isEditingEnviarEmail, setIsEditingEnviarEmail] = React.useState(false);
  const [isEditingExibirRemetente, setIsEditingExibirRemetente] =
    React.useState(false);
  const [isEditingFichas, setIsEditingFichas] = React.useState(false);
  const [isEditingPeriodoInscricao, setIsEditingPeriodoInscricao] =
    React.useState(false);
  const [isEditingApresentacaoEmpresa, setIsEditingApresentacaoEmpresa] =
    React.useState(false);
  const [isEditingFases, setIsEditingFases] = React.useState(false);
  const [isEditingOutrosRequisitos, setIsEditingOutrosRequisitos] =
    React.useState(false);
  const [isEditingIdiomas, setIsEditingIdiomas] = React.useState(false);
  const [isEditingAreasAtuacao, setIsEditingAreasAtuacao] =
    React.useState(false);
  const [isEditingEscolaridade, setIsEditingEscolaridade] =
    React.useState(false);
  const [isEditingBeneficios, setIsEditingBeneficios] = React.useState(false);
  const [isEditingDescricao, setIsEditingDescricao] = React.useState(false);
  const [isEditingModeloContratacao, setIsEditingModeloContratacao] =
    React.useState(false);
  const [isEditingNivelHierarquico, setIsEditingNivelHierarquico] =
    React.useState(false);
  const [isEditingPosicoes, setIsEditingPosicoes] = React.useState(false);
  const [isEditingLocal, setIsEditingLocal] = React.useState(false);
  const [isEditingSalario, setIsEditingSalario] = React.useState(false);
  const [isEditingCargo, setIsEditingCargo] = React.useState(false);
  const [isEditingPcd, setIsEditingPcd] = React.useState(false);
  const [isEditingDivisaoAcesso, setIsEditingDivisaoAcesso] =
    React.useState(false);
  const [vagaInitialData, setVagaInitialData] = React.useState(null);

  const intl = useIntl();

  const idiomasNiveis = [
    {
      id: 2,
      label: intl.formatMessage(
        defineMessage({
          id: "step1.idiomaBasico",
          defaultMessage: "Básico",
        })
      ),
    },
    {
      id: 3,
      label: intl.formatMessage(
        defineMessage({
          id: "step1.idiomaIntermediario",
          defaultMessage: "Intermediário",
        })
      ),
    },
    {
      id: 4,
      label: intl.formatMessage(
        defineMessage({
          id: "step1.idiomaAvancado",
          defaultMessage: "Avançado",
        })
      ),
    },
    {
      id: 5,
      label: intl.formatMessage(
        defineMessage({
          id: "step1.idiomaFluente",
          defaultMessage: "Fluente",
        })
      ),
    },
  ];

  const limiteAreas = 8;

  const lastSugestoesCargoQuery = useDebounce(formState.cargo, 500);
  const location = useLocation();
  const isVagaModelo =
    location.pathname === "/nova-vaga-modelo" ||
    location.pathname?.includes("/editar-vaga-modelo");

  const isEditingVaga =
    location.pathname?.includes("/editar-processo") ||
    location.pathname?.includes("/editar-vaga-modelo");

  const isFromVagaModelo =
    formState.isOrigemVagaModelo && location.pathname === "/novo-processo";

  const descricaoTextLength = extractTextFromHtmlString(
    formState.descricao
  ).length;

  const outrosRequisitosTextLength = extractTextFromHtmlString(
    formState.outrosRequisitos
  ).length;

  const emailMensagemTextLength = extractTextFromHtmlString(
    formState.emailMensagem
  ).length;

  const { data: sugestoesCargoData, error: sugestoesCargoError } = useSWR(
    () =>
      lastSugestoesCargoQuery?.length >= 3
        ? `${process.env.HESTIA}/sugestoes/cargos?q=${lastSugestoesCargoQuery}`
        : null,
    fetcherWithToken
  );

  const [addressFieldNode, setAddressFieldNode] = React.useState();

  const addressFieldRef = React.useCallback((node) => {
    if (node) setAddressFieldNode(node);
  }, []);

  const [toasts, addToast, removeToast] = useToaster();
  let history = useHistory();
  const { id } = useParams();

  React.useEffect(() => {
    history.listen((location) => {
      if (history.action === "POP") {
        history.replace("/");
      }
    });
  }, []);

  // pega o id da requisição na url
  const query = new URLSearchParams(location.search);

  const requisicaoId = query.get("requisicao");

  const ingles = formState.idiomasData?.find((idioma) => idioma.id === 7);
  const espanhol = formState.idiomasData?.find((idioma) => idioma.id === 4);

  const idiomasOrdenados = formState.idiomasData
    ? [
        ingles,
        espanhol,
        ...formState.idiomasData.filter(
          (idioma) => idioma.id !== 7 && idioma.id !== 4
        ),
      ]
    : [];

  React.useEffect(() => {
    if (id) setFormState({ vagaId: id });
  }, [id]);

  React.useEffect(() => {
    if (formState.cargo && !vagaInitialData) {
      setVagaInitialData(formState);
    }
  }, [formState]);

  React.useEffect(() => {
    if (window.google && addressFieldNode) {
      const autocomplete = new google.maps.places.Autocomplete(
        addressFieldNode,
        {}
      );

      autocomplete.addListener("place_changed", () => {
        setFormState({
          enderecoQuery: autocomplete.getPlace()?.formatted_address,
          enderecoFormatado: autocomplete.getPlace()?.formatted_address,
        });
        const components = autocomplete.getPlace()?.address_components;
        setFormState({
          enderecoLat: autocomplete.getPlace()?.geometry.location.lat(),
          enderecoLng: autocomplete.getPlace()?.geometry.location.lng(),
        });
        if (components) {
          setFormState({
            enderecoApiPais:
              components.find((v) => v.types.includes("country"))?.long_name ??
              "",
            enderecoApiEstado:
              components.find((v) =>
                v.types.includes("administrative_area_level_1")
              )?.short_name ?? "",
            enderecoApiCidade:
              components.find((v) =>
                v.types.includes("administrative_area_level_2")
              )?.short_name ?? "",
            enderecoApiBairro:
              components.find((v) => v.types.includes("sublocality_level_1"))
                ?.long_name ?? "",
            enderecoApiRua:
              components.find((v) => v.types.includes("route"))?.long_name ??
              "",
            enderecoApiNumero:
              components.find((v) => v.types.includes("street_number"))
                ?.long_name ?? "",
          });

          if (
            !components.find((v) =>
              v.types.includes("administrative_area_level_1")
            )
          ) {
            return setFormState({ enderecoRestricao: "somente_pais" });
          }

          if (
            !components.find((v) =>
              v.types.includes("administrative_area_level_2")
            )
          ) {
            return setFormState({ enderecoRestricao: "somente_estado" });
          }

          return setFormState({ enderecoRestricao: "somente_cidade" });
        }
      });
    }
  }, [addressFieldNode]);

  const mapRef = React.useCallback(
    (element) => {
      if (
        window.google &&
        element &&
        formState.enderecoLat &&
        formState.enderecoLng
      ) {
        const latLng = {
          lat: formState.enderecoLat,
          lng: formState.enderecoLng,
        };

        const map = new google.maps.Map(element, {
          zoom: 15,
          center: latLng,
        });

        const marker = new google.maps.Marker({
          position: latLng,
          map: map,
        });
      }
    },
    [formState.enderecoLat, formState.enderecoLng]
  );

  const [beneficiosCategorias, setBeneficiosCategorias] = React.useState();

  React.useEffect(() => {
    if (formState.beneficiosData) {
      let categorias = [];

      formState.beneficiosData.map((v) => {
        if (categorias.map((v) => v.id).includes(v.categoria.id)) return;
        categorias.push({ id: v.categoria.id, label: v.categoria.nome });
      });

      categorias = categorias.sort((a, b) => a.id - b.id);

      setBeneficiosCategorias(categorias);
    }
  }, [formState.beneficiosData]);

  React.useEffect(() => {
    window.scroll(0, 0);
  }, []);

  function renderSalario() {
    if (formState.exibirSalario) {
      return `${new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: formState.salarioMoeda,
      }).format(formState.salarioFaixaValorInicial)} - ${new Intl.NumberFormat(
        "pt-BR",
        { style: "currency", currency: formState.salarioMoeda }
      ).format(formState.salarioFaixaValorFinal)}`;
    }

    if (!formState.exibirSalario) {
      return (
        <>
          <FormattedMessage
            id="step4.salarioCombinar"
            defaultMessage="Salário a combinar"
          />
        </>
      );
    }
  }

  function renderLocal() {
    if (formState.enderecoApiPais && !formState.enderecoApiEstado) {
      return formState.enderecoApiPais;
    }

    if (formState.enderecoApiEstado && !formState.enderecoApiCidade) {
      return `${formState.enderecoApiEstado} - ${formState.enderecoApiPais}`;
    }
    if (formState.enderecoApiCidade && !formState.enderecoApiRua) {
      return `${formState.enderecoApiCidade}, ${formState.enderecoApiEstado}`;
    }

    if (formState.enderecoApiRua && formState.enderecoApiCidade) {
      return `${formState.enderecoApiRua}, ${formState.enderecoApiBairro}, ${formState.enderecoApiCidade} - ${formState.enderecoApiEstado}`;
    }
  }

  function renderEmailsIndicacao() {
    if (formState.emailsIndicacaoError)
      return (
        <option>
          {" "}
          {intl.formatMessage(
            defineMessage({
              id: "mensagem.ocorreuErro",
              defaultMessage: "Ocorreu um erro",
            })
          )}
        </option>
      );
    if (!formState.emailsIndicacaoData)
      return (
        <option value="">
          {" "}
          {intl.formatMessage(
            defineMessage({
              id: "info.carregando",
              defaultMessage: "Carregando...",
            })
          )}
        </option>
      );
    return (
      <>
        <Text as="p" size="rg" weight={600}>
          <FormattedMessage
            id="step2.titleRestringirEmails"
            defaultMessage="Restringir e-mails"
          />
        </Text>
        <Text as="p" size="rg">
          <FormattedMessage
            id="step2.descriptionRestringirEmails"
            defaultMessage="Insira abaixo a lista de e-mails ou domínios de e-mails que poderão
            indicar profissionais para a vaga. Exemplo: joão@empresa.com ou
            @empresa.com. Pressione Enter ou Tab para formar tags."
          />
        </Text>
        <Label
          title={
            <FormattedMessage
              id="step2.infoRestringirEmails"
              defaultMessage="Insira e-mails ou domínios separados por enter"
            />
          }
        >
          <CreatableSelect
            styles={{
              control: (base, state) => ({
                ...base,
                minHeight: "40px",
                background: "#fff",
                border: `1px solid rgb(200, 200, 200)`,
                borderRadius: "6px",
                width: "100%",
                color: vars.color.foreground,
              }),
            }}
            components={{ DropdownIndicator: null }}
            isClearable
            isMulti
            menuIsOpen={false}
            value={formState.emailsIndicacao}
            inputValue={formState.emailsIndicacaoInput}
            onChange={(v) => setFormState({ emailsIndicacao: v })}
            onInputChange={(v) => setFormState({ emailsIndicacaoInput: v })}
            onKeyDown={(e) => {
              if (["Enter", "Tab"].includes(e.code)) {
                if (!formState.emailsIndicacaoInput) return;
                e.preventDefault();

                if (
                  !validateEmailWithOptionalUsername(
                    formState.emailsIndicacaoInput
                  )
                )
                  return;

                setFormState((prev) => ({
                  emailsIndicacaoInput: "",
                  emailsIndicacao: [
                    ...prev.emailsIndicacao,
                    prev.emailsIndicacaoInput,
                  ],
                }));
              }
            }}
            placeholder=""
            getOptionLabel={(v) => v}
            getOptionValue={(v) => v}
          />
        </Label>
      </>
    );
  }

  function renderParceiros() {
    if (formState.parceirosError || formState.creditosEtalentError)
      return (
        <option>
          {" "}
          {intl.formatMessage(
            defineMessage({
              id: "mensagem.ocorreuErro",
              defaultMessage: "Ocorreu um erro",
            })
          )}
        </option>
      );
    if (!formState.parceirosData || !formState.creditosEtalentData)
      return (
        <option>
          {" "}
          {intl.formatMessage(
            defineMessage({
              id: "mensagem.loading",
              defaultMessage: "Carregando",
            })
          )}{" "}
        </option>
      );
    const creditos = formState.creditosEtalentData[0]["creditos_etalent"];
    return (
      <>
        <Space height=".5rem" />
        <Label
          text={
            <FormattedMessage
              id="step2.etalent"
              defaultMessage="VAGAS ETALENT - Análise DISC"
            />
          }
        />
        <div className={wrapperTooltipStyle}>
          <Checkbox
            label={
              <FormattedMessage
                id="step2.solicitarEtalent"
                defaultMessage="Solicitar o preenchimento aos profissionais na inscrição"
              />
            }
            disabled={creditos === 0}
            checked={formState.isParceiroEtalentSelecionado}
            onChange={(e) =>
              setFormState({ isParceiroEtalentSelecionado: e.target.checked })
            }
            data-testid="checkbox-etalent"
          />
          {creditos === 0 ? (
            <>
              <Tooltip
                active={active}
                setActive={setActive}
                text={
                  <FormattedMessage
                    id="step2.tooltipEtalent"
                    defaultMessage="Você não possui créditos. Consulte a nossa equipe Comercial"
                  />
                }
              />
            </>
          ) : null}
        </div>
      </>
    );
  }

  function renderFichasSelectOptions(selectedOptionId) {
    if (formState.fichasError)
      return (
        <option>
          {" "}
          {intl.formatMessage(
            defineMessage({
              id: "mensagem.ocorreuErro",
              defaultMessage: "Ocorreu um erro",
            })
          )}
        </option>
      );
    if (!formState.fichasData)
      return (
        <option value="">
          {" "}
          {intl.formatMessage(
            defineMessage({
              id: "info.carregando",
              defaultMessage: "Carregando...",
            })
          )}
        </option>
      );
    return (
      <>
        <option value="">
          {" "}
          {intl.formatMessage(
            defineMessage({
              id: "info.selecioneOpcao",
              defaultMessage: "Selecione uma opção...",
            })
          )}{" "}
        </option>
        {formState.fichasData
          .filter(
            (v) =>
              v.id === selectedOptionId ||
              !formState.fichasSelected
                .map((currentSelect) => currentSelect.fichaSelecionadaId)
                .includes(v.id)
          )
          .map((v) => (
            <option key={v.id} value={v.id}>
              {v.label}
            </option>
          ))}
      </>
    );
  }

  const currencyIsoToId = {
    BRL: 1,
    USD: 2,
  };

  function addEmailIndicacaoPostErrorToast() {
    const title = intl.formatMessage(
      defineMessage({
        id: "mensagem.ocorreuErro",
        defaultMessage: "Ocorreu um erro",
      })
    );

    const body = intl.formatMessage(
      defineMessage({
        id: "step2.bodyErro",
        defaultMessage: "Não foi possível salvar os e-mails.",
      })
    );
    const variant = "error";
    const onDismiss = (id) => removeToast(id);
    const timer = "max";

    addToast({
      title,
      variant,
      body,
      timer,
      onDismiss,
    });
  }

  function addPostEmailIndicacaoSuccessToast() {
    const title = intl.formatMessage(
      defineMessage({
        id: "post.titleSucesso",
        defaultMessage: "Sucesso!",
      })
    );

    const body = intl.formatMessage(
      defineMessage({
        id: "step2.postBodySucesso",
        defaultMessage: "Os e-mails foram cadastrados com sucesso.",
      })
    );
    const variant = "success";
    const onDismiss = (id) => removeToast(id);
    const timer = "max";

    addToast({
      title,
      variant,
      body,
      timer,
      onDismiss,
    });
  }

  function handleEmailsIndicacaoSubmit() {
    const TOKEN = getCookie(process.env.ACCESS_TOKEN);

    setIsEmailsPostPending(true);
    fetch(`${process.env.HESTIA}/emails_indicacao`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TOKEN}`,
      },
      method: "POST",
      body: JSON.stringify({ emails_dominios: formState.emailsIndicacao }),
    })
      .then((res) => {
        if (!res.ok) throw new Error();
        addPostEmailIndicacaoSuccessToast();
        return res.json();
      })
      .catch(() => {
        addEmailIndicacaoPostErrorToast();
      })
      .finally(() => {
        setIsEmailsPostPending(false);
      });
  }

  function formatBodyForPost(formState) {
    return {
      titulo: formatString(formState.cargo).trim(),
      descricao: formState.descricao,
      vaga_modelo: isVagaModelo,
      ...(isVagaModelo
        ? {
            anuncio_modelo_divisoes: formState.divisoesAcessoSelected?.map(
              (v) => v.id
            ),
            anuncios_controle_edicao_campos: {
              aceitar_indicacao: !formState.isIndicacaoLocked,
              areas_atuacao: !formState.isAreasAtuacaoLocked,
              beneficios: !formState.isBeneficiosLocked,
              canais_divulgacao: !formState.isCanaisDivulgacaoLocked,
              descricao: !formState.isDescricaoLocked,
              email_remetente: !formState.isExibirRemetenteLocked,
              escolaridade: !formState.isEscolaridadeLocked,
              fases: !formState.isFasesLocked,
              fichas: !formState.isFichasLocked,
              idiomas: !formState.isIdiomasLocked,
              localizacao: !formState.isLocalLocked,
              modelo_contratacao: !formState.isModeloContratacaoLocked,
              modelo_mensagem: !formState.isEnviarEmailLocked,
              nivel_hierarquico: !formState.isNivelHierarquicoLocked,
              parceiros: !formState.isParceirosLocked,
              pcd: !formState.isPcdLocked,
              posicoes: !formState.isPosicoesLocked,
              requisitos: !formState.isOutrosRequisitosLocked,
              salario: !formState.isSalarioLocked,
              template: !formState.isApresentacaoEmpresaLocked,
              titulo: !formState.isCargoLocked,
            },
          }
        : {}),
      posicoes: formState.posicoesQuantity,
      pcd: formState.isPcd,
      exibir_fases: false,
      confidencial: formState.isAnuncioConfidencial,
      requisitos: formState.outrosRequisitos,
      localizacao: {
        pais: formState.enderecoApiPais,
        estado: formState.enderecoApiEstado,
        cidade: formState.enderecoApiCidade,
        bairro: formState.enderecoApiBairro,
        rua: formState.enderecoApiRua,
        numero: formState.enderecoApiNumero,
        latitude:
          typeof formState.enderecoLat === "number"
            ? formState.enderecoLat.toString()
            : formState.enderecoLat,
        longitude:
          typeof formState.enderecoLng === "number"
            ? formState.enderecoLng.toString()
            : formState.enderecoLng,
        localizacao_completa: formState.enderecoFormatado,
        outras_localidades: formState.enderecoRestricao,
      },
      aceitar_indicacao: formState.isIndicacaoSelecionada
        ? formState.tipoIndicacao === "indicacao-livre"
          ? 2
          : 1
        : 0,
      suspender_vaga: formState.isSuspenderVaga,
      teste: formState.isVagaTeste,
      senha: formState.senhaVagaTeste,
      anuncio_divisao_id: formState.divisaoSelectedId,
      ...(isEditingVaga &&
      formState.dataInicio === vagaInitialData.dataInicio &&
      formState.dataFim === vagaInitialData.dataFim
        ? {}
        : {
            data_abertura: formState.dataInicio,
            data_expiracao: formState.dataFim,
          }),

      salario: {
        combinar: !formState.exibirSalario,
        minimo: formState.salarioFaixaValorInicial,
        maximo: formState.salarioFaixaValorFinal,
        moeda_id: currencyIsoToId[formState.salarioMoeda],
      },
      nivel_hierarquico_id: formState.nivelHierarquicoSelectedId,
      modelo_contratual_id: formState.modeloContratacaoSelectedId,
      niveis_escolaridade_id: formState.escolaridadeMinimaSelectedId,
      parceiros: formState.isParceiroEtalentSelecionado
        ? [{ nome: "VAGAS ETALENT - Análise DISC" }]
        : [],
      fases: formState.fasesSelected?.map((v) => v.id),
      fichas: formState.fichasSelected
        .filter(
          (v, i) =>
            // verifica se o último select tem ficha selecionada
            v.fichaSelecionadaId
        )
        .map((v) => {
          return {
            ficha_id: v.fichaSelecionadaId,
            ficha_auto: v.isPreenchimentoObrigatorio,
          };
        }),
      areas_atuacao: formState.areasAtuacaoSelected?.map((v) => v.id),
      modelo_local_trabalho_id: formState.localTrabalhoSelectedId,
      id_origem: formState.vagaData?.id,
      funcionario_responsavel_id: formState.responsavelSelectedId,
      subdivisoes: formState.subdivisoesSelected.map((v) => v.id),
      template_id: formState.apresentacaoId,
      requisicao_vaga_id: requisicaoId,
      idiomas: formState.idiomasSelected.map((v) => ({
        idioma_id: v.id,
        idioma_nivel_id: v.levelId,
      })),
      enviar_mensagem: formState.isEnviarEmail,
      nome_remetente: formState.nomeRemetente,
      email_remetente: formState.emailRemetente,
      corpo_email: formState.emailMensagem,
      ocultar_remetente: formState.isExibirRemetente === false,
      ...(formState.modeloEmailSelectedId !== 999999
        ? { mensagem_padrao_id: formState.modeloEmailSelectedId }
        : {}),
      beneficios: formState.beneficiosSelected.map((v) => ({
        id: v.id,
        ...(Number(v.value) ? { valor: Number(v.value) } : {}),
      })),

      ...(!formState.isVagaTeste
        ? {
            canais_publicacao: formState.canaisDivulgacaoSelected.map(
              (v) => v.id
            ),
          }
        : {}),
    };
  }

  const postToastBody = {
    acima_do_permitido_60_ou_120_dias: intl.formatMessage(
      defineMessage({
        id: "post.erroPeriodoAcima",
        defaultMessage:
          "Data final do período de inscrição acima do permitido.",
      })
    ),
    data_de_abertura_ou_data_expiracao_invalidas: intl.formatMessage(
      defineMessage({
        id: "post.erroDataInicial",
        defaultMessage:
          "Data inicial ou final do período de inscrição inválida.",
      })
    ),
    "O campo senha não pode ser enviado caso teste seja false":
      intl.formatMessage(
        defineMessage({
          id: "post.erroVagaTeste",
          defaultMessage:
            "O campo acesso restrito (vaga-teste) não está selecionado, mas há uma senha informada.",
        })
      ),
  };

  function addFormPostErrorToast(message) {
    const title = intl.formatMessage(
      defineMessage({
        id: "mensagem.ocorreuErro",
        defaultMessage: "Ocorreu um erro",
      })
    );
    const body =
      postToastBody[message] ??
      intl.formatMessage(
        defineMessage({
          id: "step4.postBodyErro",
          defaultMessage:
            "Não foi possível publicar a vaga. Tente novamente mais tarde.",
        })
      );

    const variant = "error";
    const onDismiss = (id) => removeToast(id);
    const timer = "max";

    addToast({
      title,
      variant,
      body,
      timer,
      onDismiss,
    });
  }

  function handleFormPost() {
    const formatted = formatBodyForPost(formState);

    const body = deepRemoveUndefinedNullEmptyString(formatted);

    const TOKEN = getCookie(process.env.ACCESS_TOKEN);

    setIsPostPending(true);

    fetch(
      isVagaModelo
        ? `${process.env.HESTIA}/anuncios_modelo`
        : `${process.env.HESTIA}/anuncios`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
        method: "POST",
        body: JSON.stringify(body),
      }
    )
      .then((res) => {
        if (!res.ok)
          return res.json().then((json) => {
            throw new Error(
              json.code === 412
                ? json.error?.periodo_veiculacao?.[0] ??
                  json.error?.datas_veiculacao?.[0] ??
                  json.error?.senha_somente_em_teste?.[0]
                : ""
            );
          });
        return res.json();
      })
      .then((json) => {
        setFormState({ postResponse: json });
        history.push(
          isVagaModelo
            ? "/vaga-modelo-criada"
            : requisicaoId
            ? `/vaga-criada?requisicao=${requisicaoId}`
            : "/vaga-criada"
        );
      })
      .catch((error) => {
        addFormPostErrorToast(error.message);
      })
      .finally(() => {
        setIsPostPending(false);
      });
  }

  function deepRemoveUndefinedNullEmptyString(obj) {
    let newObj = {};
    Object.keys(obj).forEach((key) => {
      if (Array.isArray(obj[key])) return (newObj[key] = obj[key]);
      if (isObject(obj[key]))
        return (newObj[key] = deepRemoveUndefinedNullEmptyString(obj[key]));
      if (obj[key] !== undefined && obj[key] !== null && obj[key] !== "")
        return (newObj[key] = obj[key]);
    });
    return newObj;
  }

  function addFormPatchErrorToast(message) {
    const title = intl.formatMessage(
      defineMessage({
        id: "mensagem.ocorreuErro",
        defaultMessage: "Ocorreu um erro",
      })
    );
    const body =
      postToastBody[message] ??
      intl.formatMessage(
        defineMessage({
          id: "sobreEmpresa.patchBodyErro",
          defaultMessage:
            "Não foi possível atualizar a vaga. Tente novamente mais tarde.",
        })
      );

    const variant = "error";
    const onDismiss = (id) => removeToast(id);
    const timer = "max";

    addToast({
      title,
      variant,
      body,
      timer,
      onDismiss,
    });
  }

  function handleFormPatch() {
    const body = formatBodyForPost(formState);

    const TOKEN = getCookie(process.env.ACCESS_TOKEN);

    setIsPostPending(true);

    fetch(
      isVagaModelo
        ? `${process.env.HESTIA}/anuncios_modelo/${formState.vagaId}`
        : `${process.env.HESTIA}/anuncios/${formState.vagaId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
        method: "PATCH",
        body: JSON.stringify(body),
      }
    )
      .then((res) => {
        if (!res.ok)
          return res.json().then((json) => {
            throw new Error(
              json.code === 412
                ? json.error?.periodo_veiculacao?.[0] ??
                  json.error?.datas_veiculacao?.[0] ??
                  json.error?.senha_somente_em_teste?.[0]
                : ""
            );
          });
        return res.json();
      })
      .then((json) => {
        setFormState({ patchResponse: json });
        window.location.href = isVagaModelo
          ? `${process.env.GLOBAL_URL}/move-to/vagas-modelo?url_params=configuracoes`
          : `${process.env.GLOBAL_URL}/vagas`;
      })
      .catch((error) => {
        addFormPatchErrorToast(error.message);
      })
      .finally(() => {
        setIsPostPending(false);
      });
  }

  const isSubmitVagaModeloDisabled =
    !formState.cargo ||
    !formState.divisoesAcessoSelected?.length ||
    (formState.isEnviarEmail && !emailMensagemTextLength);

  const isSubmitVagaDisabled =
    (!formState.cargo ||
      !formState.modeloContratacaoSelectedId ||
      !formState.nivelHierarquicoSelectedId ||
      !formState.enderecoFormatado ||
      !formState.localTrabalhoSelectedId ||
      !formState.enderecoRestricao ||
      descricaoTextLength + outrosRequisitosTextLength < 300 ||
      !descricaoTextLength ||
      formState.salarioFaixaValorInicial > formState.salarioFaixaValorFinal ||
      (formState.exibirSalario && formState.salarioFaixaValorInicial < 1) ||
      !formState.escolaridadeMinimaSelectedId ||
      !formState.areasAtuacaoSelected?.length ||
      !formState.fasesSelected?.length ||
      formState.isAnuncioConfidencial === null ||
      (formState.isAnuncioConfidencial === false &&
        !formState.apresentacaoId) ||
      !formState.dataInicio ||
      !formState.dataFim ||
      !formState.divisaoSelectedId ||
      !formState.responsavelSelectedId ||
      (formState.isEnviarEmail &&
        (!emailMensagemTextLength ||
          (formState.isExibirRemetente &&
            (!formState.nomeRemetente || !formState.emailRemetente))))) &&
    !isVagaModelo;

  function addImageUploadErrorToast() {
    const title = intl.formatMessage(
      defineMessage({
        id: "mensagem.ocorreuErro",
        defaultMessage: "Ocorreu um erro",
      })
    );
    const body = intl.formatMessage(
      defineMessage({
        id: "step1.uploadBodyErroTamanho",
        defaultMessage:
          "Sua imagem está maior que o tamanho máximo permitido (5MB), ou fora dos formatos permitidos (JPG, JPEG e PNG).",
      })
    );

    const variant = "error";
    const onDismiss = (id) => removeToast(id);
    const timer = "max";

    addToast({
      title,
      variant,
      body,
      timer,
      onDismiss,
    });
  }

  function addImageInsertErrorToast() {
    const title = intl.formatMessage(
      defineMessage({
        id: "mensagem.ocorreuErro",
        defaultMessage: "Ocorreu um erro",
      })
    );

    const body = intl.formatMessage(
      defineMessage({
        id: "step1.imagemUltrapassouDimensoes",
        defaultMessage:
          "A imagem não pode ser maior que 2000px de largura e 1000px de altura.",
      })
    );
    const variant = "error";
    const onDismiss = (id) => removeToast(id);
    const timer = "max";

    addToast({
      title,
      variant,
      body,
      timer,
      onDismiss,
    });
  }

  return (
    <div className={stepStyle}>
      {formState.isVagaPending ? (
        <>
          <Space />

          <FormCardLoader />
          <FormCardLoader />
          <FormCardLoader />
        </>
      ) : (
        <>
          <Space height={"1.5rem"} />

          {isVagaModelo ? (
            <>
              <InfoBox
                variant="whiteBackground"
                illustration={<IlustracaoPrancheta />}
                title={
                  <FormattedMessage
                    id="step4.titleBloqueio"
                    defaultMessage="Clique no cadeado para bloquear!"
                  />
                }
                description={
                  <FormattedMessage
                    id="step4.descriptonBloqueio"
                    defaultMessage="Você pode controlar as informações que não poderão ser
                  editadas ao publicar uma vaga. {br}
                  <strong>Atenção!</strong> Campos obrigatórios na criação da
                  vaga só poderão ser bloqueados se estiverem preenchidos"
                    values={{
                      strong: (chunks) => <strong>{chunks}</strong>,
                      br: <br />,
                    }}
                  />
                }
              />
            </>
          ) : (
            <>
              <InfoBox
                variant="whiteBackground"
                illustration={<IlustracaoPrancheta />}
                title={"Confirme os dados!"}
                description={
                  <FormattedMessage
                    id="step4.visualizarAnuncio"
                    defaultMessage="Visualize abaixo todas as informações do processo seletivo."
                  />
                }
                actionContent={
                  <Button
                    className={`${primaryButton} ${inputVariants["form-buttons"]}`}
                    type="button"
                    onClick={() => setIsModalOpen(true)}
                    data-testid="btn-ver-anuncio"
                  >
                    <FormattedMessage
                      id="step4.btnVerAnuncio"
                      defaultMessage="Ver anúncio"
                    />
                  </Button>
                }
              />

              {isModalOpen ? (
                <Modal
                  className={modalStyle}
                  onClose={() => setIsModalOpen(false)}
                >
                  <Text size="lg" weight={600} as="h2">
                    <FormattedMessage
                      id="step4.titleAnuncioVaga"
                      defaultMessage="Anúncio da vaga"
                    />
                  </Text>
                  <Space height={"1.5rem"} />
                  <Text size="rg" as="p">
                    <FormattedMessage
                      id="step4.titleConfirmacao"
                      defaultMessage="Confirme os dados!"
                    />
                  </Text>

                  <Space height=".25rem" />
                  <Text size="rg" as="p" weight={600}>
                    <FormattedMessage
                      id="step4.descriptionConfirmacao"
                      defaultMessage="Visualize abaixo todas as informações do processo seletivo."
                    />
                  </Text>
                  <Space height={"1.5rem"} />

                  <div className={previewEmpresaStyle}>
                    <div className={previewEmpresaContentStyle}>
                      <div className={previewInfoEmpresaStyle}>
                        {formState.isAnuncioConfidencial === false ? (
                          <img
                            className={previewLogoStyle}
                            src={
                              formState.apresentacoesEmpresaData?.find(
                                (v) => v.id == formState.apresentacaoId
                              )?.logotipo
                            }
                            alt="logotipo da empresa"
                          ></img>
                        ) : (
                          <IlustracaoPredio />
                        )}
                        <div>
                          <div className={infoVagaPublicada}>
                            <IconeRelogio
                              fill={vars.color.foreground}
                              width={14}
                              height={14}
                            />
                            <Text
                              size="sm"
                              fontColor={vars.color.lightForeground}
                            >
                              <FormattedMessage
                                id="step4.vagaPublicadaHoje"
                                defaultMessage="Publicada hoje"
                              />
                            </Text>
                          </div>
                          {formState.cargo ? (
                            <Text size="lg" weight={600} as="h3">
                              {formatString(formState.cargo)}
                            </Text>
                          ) : null}
                          {formState.isAnuncioConfidencial === false ? (
                            <Text size="rg" as="p">
                              {
                                formState.apresentacoesEmpresaData?.find(
                                  (v) => v.id == formState.apresentacaoId
                                )?.nome_empresa
                              }
                            </Text>
                          ) : (
                            <Text size="rg" as="p">
                              <FormattedMessage
                                id="step4.anuncioConfidencial"
                                defaultMessage="Anúncio confidencial"
                              />
                            </Text>
                          )}
                          <Text
                            size="sm"
                            as="p"
                            fontColor={vars.color.lightForeground}
                          >
                            {
                              formState.niveisHierarquicosData?.find(
                                (v) =>
                                  v.id == formState.nivelHierarquicoSelectedId
                              )?.label
                            }
                          </Text>
                        </div>
                      </div>
                    </div>
                    <div className={candidatarSpaceStyle}>
                      <div className={candidatarCardStyle}>
                        <div className={iconeCompartilharStyle}>
                          {formState.isPcd === true ? (
                            <IconePcd
                              fill={vars.color.foreground}
                              width={20}
                              height={20}
                            />
                          ) : null}
                          <IconeCompartilhar
                            fill={vars.color.foreground}
                            width={20}
                            height={20}
                          />
                        </div>

                        {formState.isAnuncioConfidencial === false ? (
                          <div
                            className={mapStyle}
                            ref={mapRef}
                            style={{ height: "150px", width: "300px" }}
                          ></div>
                        ) : null}
                        <div className={candidatarContentStyle}>
                          {formState.cargo ? (
                            <Text size="md" weight={600} as="p">
                              {formatString(formState.cargo)}
                            </Text>
                          ) : null}
                          <Text
                            size="rg"
                            as="p"
                            fontColor={vars.color.lightForeground}
                          >
                            <FormattedMessage
                              id="step4.localTrabalho"
                              defaultMessage="Local de Trabalho: "
                            />
                            {
                              formState.locaisTrabalhoData?.find(
                                (v) => v.id == formState.localTrabalhoSelectedId
                              )?.nome
                            }
                          </Text>
                          <div className={btnFakeCandidatura}>
                            <FormattedMessage
                              id="step4.fakeBtnCandidatura"
                              defaultMessage="Candidate-se"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Space height={"1rem"} />
                  <div className={previewMainStyle}>
                    <div className={previewMainContentStyle}>
                      <div>
                        <>
                          <div className={salarioStyle}>
                            <IconeDolar
                              fill={vars.color.foreground}
                              width={20}
                              height={20}
                              style={{ flexShrink: 0 }}
                            />
                            <Text
                              size="sm"
                              fontColor={vars.color.lightForeground}
                            >
                              {renderSalario()}
                            </Text>
                          </div>
                        </>
                      </div>

                      <div className={containerInfoLocalStyle}>
                        <IconeMapa
                          fill={vars.color.foreground}
                          width={20}
                          height={20}
                          style={{ flexShrink: 0 }}
                        />
                        <Text size="sm" fontColor={vars.color.lightForeground}>
                          {renderLocal()}
                        </Text>
                      </div>
                      <div className={containerInfoModeloStyle}>
                        <IconeIdCard
                          fill={vars.color.foreground}
                          width={20}
                          height={20}
                          style={{ flexShrink: 0 }}
                        />
                        <Text size="sm" fontColor={vars.color.lightForeground}>
                          {
                            formState.modelosContratacaoData?.find(
                              (v) =>
                                v.id == formState.modeloContratacaoSelectedId
                            )?.label
                          }
                        </Text>
                      </div>
                      <Space height={"1.5rem"} />
                      <div>
                        <Space height={"1.5rem"} />
                        <Text size="lg" weight={600}>
                          <FormattedMessage
                            id="step4.previewDescricao"
                            defaultMessage="Descrição"
                          />
                        </Text>
                        <div
                          style={{
                            overflow: "auto",
                            overflowWrap: "break-word",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: formState.descricao,
                          }}
                        ></div>
                        <Space height={"1.5rem"} />
                        <Text size="lg" weight={600}>
                          <FormattedMessage
                            id="step1.titleRequisitos"
                            defaultMessage="Requisitos"
                          />
                        </Text>
                        <Space height={"1.5rem"} />
                        <Text size="sm" weight={600}>
                          <FormattedMessage
                            id="step4.previewLabelEscolaridade"
                            defaultMessage={"Escolaridade mínima"}
                          />
                        </Text>
                        <Space height={"0.5rem"} />
                        <Text size="sm">
                          <span className={previewTagStyle}>
                            {
                              formState.escolaridadeMinimaData?.find(
                                (v) =>
                                  v.id == formState.escolaridadeMinimaSelectedId
                              )?.label
                            }
                          </span>
                        </Text>
                        <Space height={"1rem"} />

                        {formState.idiomasSelected?.length >= 1 ? (
                          <>
                            <Text size="sm" weight={600}>
                              <FormattedMessage
                                id="step1.labelTextIdiomas"
                                defaultMessage="Idiomas"
                              />
                            </Text>
                            <Space height={"0.5rem"} />
                            <Text size="sm" weight={600}>
                              <span className={previewTagListStyle}>
                                {formState.idiomasSelected.map((v) => (
                                  <span key={v.id} className={previewTagStyle}>
                                    {`${v.label} - ${v.levelLabel}`}
                                  </span>
                                ))}
                              </span>
                            </Text>
                          </>
                        ) : null}
                        <Space height={"1.5rem"} />
                        {formState.outrosRequisitos ? (
                          <>
                            <Text size="sm" weight={600} as="h3">
                              <FormattedMessage
                                id="step1.labelTextOutrosRequisitos"
                                defaultMessage="Outros requisitos"
                              />
                            </Text>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: formState.outrosRequisitos,
                              }}
                            ></div>
                          </>
                        ) : null}

                        {formState.beneficiosSelected?.length >= 1 ? (
                          <div className={listBenefits}>
                            <Text size="lg" weight={600} as="h3">
                              <FormattedMessage
                                id="step1.titleBeneficios"
                                defaultMessage="Benefícios"
                              />
                            </Text>
                            {formState.beneficiosSelected.map((v) => (
                              <div className={benefitItemPreview} key={v.id}>
                                <IconesBeneficios
                                  aria-hidden="true"
                                  dangerouslySetInnerHTML={{
                                    __html: formState.beneficiosData?.find(
                                      (b) => b.id === v.id
                                    ).imagem,
                                  }}
                                />
                                <Text size="sm" as="p">
                                  {
                                    formState.beneficiosData?.find(
                                      (b) => b.id === v.id
                                    ).label
                                  }
                                </Text>{" "}
                                {v.value ? (
                                  <Text size="xs" as="p">
                                    {new Intl.NumberFormat("pt-BR", {
                                      style: "currency",
                                      currency: "BRL",
                                    }).format(v.value)}
                                  </Text>
                                ) : null}
                              </div>
                            ))}
                          </div>
                        ) : null}

                        <Space height={"2rem"} />
                        {formState.isAnuncioConfidencial === false ? (
                          <>
                            <Text size="lg" weight={600}>
                              <FormattedMessage
                                id="step4.titleApresentacaoEmpresa"
                                defaultMessage="Apresentação da empresa"
                              />
                            </Text>

                            <Space height={"1rem"} />

                            <Text as="p" size="rg">
                              {
                                formState.apresentacoesEmpresaData?.find(
                                  (v) => v.id == formState.apresentacaoId
                                )?.nome_empresa
                              }
                            </Text>

                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  formState.apresentacoesEmpresaData?.find(
                                    (v) => v.id == formState.apresentacaoId
                                  )?.descricao,
                              }}
                            ></div>

                            <Space height={"2rem"} />
                          </>
                        ) : null}
                      </div>
                      <Button
                        className={`${primaryButton} ${inputVariants["form-buttons"]}`}
                        onClick={() => setIsModalOpen(false)}
                      >
                        <FormattedMessage
                          id="botao.fechar"
                          defaultMessage="Fechar"
                        />
                      </Button>
                    </div>
                    <div className={candidatarSpaceStyle}></div>
                  </div>
                </Modal>
              ) : null}
            </>
          )}

          <Space height={"1rem"} />
          <form
            className={formStep4Style}
            onSubmit={(e) => {
              e.preventDefault();
              isEditingVaga ? handleFormPatch() : handleFormPost();
            }}
          >
            {/* edição */}

            <FormCard
              title={
                <FormattedMessage id="step4.anuncio" defaultMessage="Anúncio" />
              }
            >
              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  <FormattedMessage id="step4.cargo" defaultMessage="Cargo *" />
                }
                isEditing={isEditingCargo}
                setIsEditing={setIsEditingCargo}
                isLocked={formState.isCargoLocked}
                setIsLocked={(v) => setFormState({ isCargoLocked: v })}
                isVagaModelo={isVagaModelo}
                isLockNotAllowed={!formState.cargo}
                invalid={!formState.cargo}
                dataTestIdBtn="editar-cargo"
                dataTestIdLock="bloquear-cargo"
              />
              <Space height=".5rem" />
              {isEditingCargo ? (
                <>
                  <Combobox
                    data={sugestoesCargoData?.data ?? []}
                    id="cargo"
                    placeholder={intl.formatMessage(
                      defineMessage({
                        id: "step1.placeholderCargo",
                        defaultMessage: "Escolha um cargo",
                      })
                    )}
                    error={sugestoesCargoError}
                    isLoading={!sugestoesCargoData && !sugestoesCargoError}
                    getItemId={(item) => item.id}
                    getItemLabel={(item) =>
                      `${item.titulo} - ${
                        item.id_legado ? `v${item.id_legado}` : item.id
                      } (${
                        item.vaga_modelo
                          ? intl.formatMessage(
                              defineMessage({
                                id: "step1.vagaModelo",
                                defaultMessage: "vaga-modelo",
                              })
                            )
                          : intl.formatMessage(
                              defineMessage({
                                id: "step1.vagaRecorrente",
                                defaultMessage: "vaga recorrente",
                              })
                            )
                      })`
                    }
                    getSelectedItemLabel={(item) => item.titulo}
                    query={formState.cargo}
                    setQuery={(v) =>
                      setFormState({ cargo: v, tempOrigemVaga: {} })
                    }
                    onSelectedChange={(e) => {
                      setFormState({
                        origemVaga: {},
                        tempOrigemVaga: e,
                        tempVagaId: e.id,
                      });
                    }}
                    data-testid="input-cargo-edicao"
                    required
                    errorMessage={
                      <FormattedMessage
                        id="erro.campoObrigatorio"
                        defaultMessage="Campo obrigatório"
                      />
                    }
                    text={
                      <FormattedMessage
                        id="step1.vagaAindaNaoCriada"
                        defaultMessage="Você ainda não criou uma vaga com este cargo"
                      />
                    }
                    overlayDataTestId="cargo-overlay"
                  />
                  <Space />

                  {formState.tempOrigemVaga?.vaga_modelo && formState.cargo ? (
                    <>
                      <InfoBox
                        illustration={<IlustracaoPrancheta />}
                        title={
                          <FormattedMessage
                            id="step1.titleUtilizarVagaModelo"
                            defaultMessage="Você escolheu uma vaga-modelo!"
                          />
                        }
                        description={
                          <FormattedMessage
                            id="step1.descriptionUtilizarVagaModelo"
                            defaultMessage="Deseja utilizá-la na abertura do seu processo seletivo?"
                          />
                        }
                        actionContent={
                          <Button
                            className={`${primaryButton} ${inputVariants["form-buttons"]}`}
                            data-testid="btn-usar-vaga"
                            onClick={() => {
                              setSelectedStepId(4);
                              setFormState((prev) => ({
                                vagaId: prev.tempVagaId,
                                origemVaga: prev.tempOrigemVaga,
                                tempOrigemVaga: null,
                              }));
                            }}
                          >
                            <FormattedMessage
                              id="step1.btnUsarVaga"
                              defaultMessage="Usar vaga"
                            />
                          </Button>
                        }
                      />
                    </>
                  ) : null}

                  {!formState.tempOrigemVaga?.vaga_modelo &&
                  formState.tempOrigemVaga?.id &&
                  formState.cargo ? (
                    <>
                      <InfoBox
                        illustration={<IlustracaoPrancheta />}
                        title={
                          <FormattedMessage
                            id="step1.titleUtilizarVagaRecorrente"
                            defaultMessage="Você já publicou esta vaga!"
                          />
                        }
                        description={
                          <FormattedMessage
                            id="step1.descriptionUtilizarVagaRecorrente"
                            defaultMessage="Deseja utilizá-la na abertura do seu processo seletivo?"
                          />
                        }
                        actionContent={
                          <Button
                            className={`${primaryButton} ${inputVariants["form-buttons"]}`}
                            data-testid="btn-usar-vaga"
                            onClick={() => {
                              setSelectedStepId(4);
                              setFormState((prev) => ({
                                vagaId: prev.tempVagaId,
                                origemVaga: prev.tempOrigemVaga,
                                tempOrigemVaga: null,
                              }));
                            }}
                          >
                            <FormattedMessage
                              id="step1.btnUsarVaga"
                              defaultMessage="Usar vaga"
                            />
                          </Button>
                        }
                      />
                    </>
                  ) : null}
                </>
              ) : (
                <>
                  {formState.cargo ? (
                    <Text size="sm" as="p">
                      {formatString(formState.cargo)}
                    </Text>
                  ) : null}
                </>
              )}
              <div className={separatorStyle}></div>
              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  <FormattedMessage
                    id="step4.titleVagaPcd"
                    defaultMessage="Vaga exclusiva para PCD:"
                  />
                }
                isEditing={isEditingPcd}
                setIsEditing={setIsEditingPcd}
                isLocked={formState.isPcdLocked}
                setIsLocked={(v) => setFormState({ isPcdLocked: v })}
                isVagaModelo={isVagaModelo}
                dataTestIdBtn="editar-pcd"
                dataTestIdLock="bloquear-pcd"
              />
              <Space height=".5rem" />
              {isEditingPcd ? (
                <Switch
                  label={
                    <FormattedMessage
                      id="step1.labelVagaPcd"
                      defaultMessage="Cargo exclusivo para PCD (pessoa com deficiência)"
                    />
                  }
                  checked={formState.isPcd}
                  onChange={(e) => setFormState({ isPcd: e.target.checked })}
                  data-testid="switch-pcd"
                />
              ) : (
                <>
                  {formState.isPcd ? (
                    <div className={wrapperIconePcd}>
                      <span className={previewTagStyle}>
                        <IconePcd
                          fill={vars.color.foreground}
                          width={16}
                          height={16}
                        />
                      </span>
                      <Space width=".5rem" />
                      <Text size="sm" as="p">
                        <FormattedMessage
                          id="step4.switchSim"
                          defaultMessage="Sim"
                        />
                      </Text>
                    </div>
                  ) : (
                    <>
                      <Text size="sm" as="p">
                        <FormattedMessage
                          id="step4.switchNão"
                          defaultMessage="Não"
                        />
                      </Text>
                    </>
                  )}
                </>
              )}
              <div className={separatorStyle}></div>
              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  isVagaModelo ? (
                    <FormattedMessage
                      id="step1.tipoContratacaoOpcional"
                      defaultMessage={"Tipo de contratação"}
                    />
                  ) : (
                    <FormattedMessage
                      id="step1.tipoContratacaoObrigatorio"
                      defaultMessage={"Tipo de contratação *"}
                    />
                  )
                }
                isEditing={isEditingModeloContratacao}
                setIsEditing={setIsEditingModeloContratacao}
                isLocked={formState.isModeloContratacaoLocked}
                setIsLocked={(v) =>
                  setFormState({ isModeloContratacaoLocked: v })
                }
                isVagaModelo={isVagaModelo}
                isLockNotAllowed={!formState.modeloContratacaoSelectedId}
                invalid={
                  !formState.modeloContratacaoSelectedId && !isVagaModelo
                }
                dataTestIdBtn="editar-modelo-contratacao"
                dataTestIdLock="bloquear-modelo-contratacao"
              />
              <Space height=".5rem" />
              {isEditingModeloContratacao ? (
                <Select
                  aria-label="Modelo de contratação"
                  value={formState.modeloContratacaoSelectedId}
                  onChange={(e) => {
                    setFormState({
                      modeloContratacaoSelectedId: Number(e.target.value),
                    });
                    if (e.target.value === "2")
                      setFormState({ nivelHierarquicoSelectedId: 28 });
                  }}
                  required={!isVagaModelo}
                  shouldValidate={hasTriedToSubmit}
                  errorMessage={
                    <FormattedMessage
                      id="erro.campoObrigatorio"
                      defaultMessage="Campo obrigatório"
                    />
                  }
                  data-testid="select-modelo-contratacao"
                >
                  {renderSelectOptions({
                    data: formState.modelosContratacaoData,
                    error: formState.modelosContratacaoError,
                    errorMessage: intl.formatMessage(
                      defineMessage({
                        id: "select.erro",
                        defaultMessage: "Ocorreu um erro",
                      })
                    ),
                    loadingMessage: intl.formatMessage(
                      defineMessage({
                        id: "select.loading",
                        defaultMessage: "Carregando...",
                      })
                    ),
                    selectOptionMessage: intl.formatMessage(
                      defineMessage({
                        id: "select.escolherOpcao",
                        defaultMessage: "Selecione uma opção...",
                      })
                    ),
                  })}
                </Select>
              ) : (
                <div className={rowStyle}>
                  <IconeIdCard
                    fill={vars.color.foreground}
                    width={20}
                    height={20}
                  />
                  <Text size="sm" as="p">
                    {
                      formState.modelosContratacaoData?.find(
                        (v) => v.id == formState.modeloContratacaoSelectedId
                      )?.label
                    }
                  </Text>
                </div>
              )}
              <div className={separatorStyle}></div>

              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  <FormattedMessage
                    id="step4.posicoes"
                    defaultMessage="Número de posições"
                  />
                }
                isEditing={isEditingPosicoes}
                setIsEditing={setIsEditingPosicoes}
                isLocked={formState.isPosicoesLocked}
                setIsLocked={(v) => setFormState({ isPosicoesLocked: v })}
                isVagaModelo={isVagaModelo}
                dataTestIdBtn="editar-posicoes"
                dataTestIdLock="bloquear-posicoes"
              />
              <Space height=".5rem" />
              {isEditingPosicoes ? (
                <ControlePosicoes
                  formState={formState}
                  setFormState={setFormState}
                />
              ) : (
                <div className={rowStyle}>
                  <IconeUserDetail
                    fill={vars.color.foreground}
                    width={20}
                    height={20}
                  />
                  <Text size="sm" as="p">
                    {formState.posicoesQuantity}
                  </Text>
                </div>
              )}
              <div className={separatorStyle}></div>
              <Space height=".5rem" />

              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  isVagaModelo ? (
                    <FormattedMessage
                      id="step1.titleDescricaoOpcional"
                      defaultMessage={"Descrição"}
                    />
                  ) : (
                    <FormattedMessage
                      id="step1.titleDescricaoObrigatorio"
                      defaultMessage={"Descrição *"}
                    />
                  )
                }
                isEditing={isEditingDescricao}
                setIsEditing={setIsEditingDescricao}
                isLocked={formState.isDescricaoLocked}
                setIsLocked={(v) => setFormState({ isDescricaoLocked: v })}
                isVagaModelo={isVagaModelo}
                isLockNotAllowed={
                  descricaoTextLength < 300 ||
                  descricaoTextLength + outrosRequisitosTextLength < 300
                }
                invalid={
                  descricaoTextLength + outrosRequisitosTextLength < 300 &&
                  !isVagaModelo
                }
                dataTestIdBtn="editar-descricao"
                dataTestIdLock="bloquear-descricao"
              />
              {isEditingDescricao ? (
                <>
                  <Space height=".5rem" />
                  <Alert>
                    <div className={infoIconContainer}>
                      <InfoIcon width={20} height={20} />
                    </div>
                    <Text size="sm" as="p">
                      <FormattedMessage
                        id="step1.cargos"
                        defaultMessage="Torne sua descrição mais engajadora com as sugestões da nossa <a></a>."
                        values={{
                          a: (chunks) => (
                            <a
                              href={
                                "https://forbusiness.vagas.com.br/modelos-de-descricao-de-cargo/?utm_source=plataforma&utm[…]ataforma&utm_campaign=clientes-biblioteca&utm_id=produto"
                              }
                              target="_blank"
                              style={{
                                color: vars.color.brand,
                                textDecoration: "none",
                              }}
                            >
                              {chunks}
                              <b>
                                <FormattedMessage
                                  id="step1.linkBiblioteca"
                                  defaultMessage="biblioteca de cargos"
                                />
                              </b>
                            </a>
                          ),
                        }}
                      />
                    </Text>
                  </Alert>
                  <TextEditor
                    value={formState.descricao}
                    onChange={(e) => setFormState({ descricao: e })}
                    length={descricaoTextLength}
                    isValid={
                      descricaoTextLength + outrosRequisitosTextLength >= 300 ||
                      isVagaModelo
                    }
                    shouldValidate={hasTriedToSubmit}
                    placeholder={intl.formatMessage(
                      defineMessage({
                        id: "step1.placeholderDescricaoCargo",
                        defaultMessage:
                          "O que a pessoa contratada irá fazer? Como será o dia a dia dessa pessoa?\nQuais são os pré-requisitos técnicos obrigatórios para essa posição?",
                      })
                    )}
                    errorMessage={
                      <FormattedMessage
                        id="step1.erroDescricao"
                        defaultMessage="Campo obrigatório. O campo descrição precisa de pelo menos 300 caracteres. Este valor pode ser dividido com o campo Outros Requisitos. :)"
                      />
                    }
                    infoMessage={
                      <FormattedMessage
                        id="step1.infoDescricao"
                        defaultMessage="Preencha pelo menos 300 caracteres incluindo o campo Outros Requisitos, se preferir."
                      />
                    }
                    imageUploadUrl={`${process.env.HESTIA}/upload_imagens`}
                    onImageUploadError={() => addImageUploadErrorToast()}
                    onImageInsertError={() => addImageInsertErrorToast()}
                    isVariablesHidden
                  />
                </>
              ) : (
                <Text size="sm" as="div">
                  <div
                    style={{ overflow: "auto", overflowWrap: "break-word" }}
                    dangerouslySetInnerHTML={{ __html: formState.descricao }}
                  ></div>
                </Text>
              )}
              <div className={separatorStyle}></div>
              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  <FormattedMessage
                    id="step1.labelTextOutrosRequisitos"
                    defaultMessage="Outros requisitos"
                  />
                }
                isEditing={isEditingOutrosRequisitos}
                setIsEditing={setIsEditingOutrosRequisitos}
                isLocked={formState.isOutrosRequisitosLocked}
                setIsLocked={(v) =>
                  setFormState({ isOutrosRequisitosLocked: v })
                }
                isVagaModelo={isVagaModelo}
                dataTestIdBtn="editar-outros-requisitos"
                dataTestIdLock="bloquear-outros-requisitos"
              />
              <Space height=".5rem" />
              {isEditingOutrosRequisitos ? (
                <>
                  <TextEditor
                    value={formState.outrosRequisitos}
                    placeholder={intl.formatMessage(
                      defineMessage({
                        id: "step1.placeholderOutrosRequisitos",
                        defaultMessage:
                          "Habilidades interpessoais (exemplo: proatividade, boa comunicação).\nDiferenciais",
                      })
                    )}
                    onChange={(e) => setFormState({ outrosRequisitos: e })}
                    id="outros-requisitos"
                    isImageHidden
                    isVideoHidden
                    isVariablesHidden
                    length={outrosRequisitosTextLength}
                    isVariablesHidden
                  />
                </>
              ) : (
                <Text size="sm" as="div">
                  <div
                    style={{ overflow: "auto", overflowWrap: "break-word" }}
                    dangerouslySetInnerHTML={{
                      __html: formState.outrosRequisitos,
                    }}
                  ></div>
                </Text>
              )}
              <div className={separatorStyle}></div>
              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  <FormattedMessage
                    id="step1.labelTextIdiomas"
                    defaultMessage="Idiomas"
                  />
                }
                isEditing={isEditingIdiomas}
                setIsEditing={setIsEditingIdiomas}
                isLocked={formState.isIdiomasLocked}
                setIsLocked={(v) => setFormState({ isIdiomasLocked: v })}
                isVagaModelo={isVagaModelo}
                dataTestIdBtn="editar-idiomas"
                dataTestIdLock="bloquear-idiomas"
              />
              <Space height=".5rem" />
              {isEditingIdiomas ? (
                <>
                  <Multi
                    name="idiomas"
                    options={idiomasOrdenados
                      ?.map((v) =>
                        idiomasNiveis.map((level) => ({
                          ...v,
                          uid: `${v.id}-${level.id}`,
                          levelLabel: level.label,
                          label: `${v.nome} - ${level.label}`,
                          levelId: level.id,
                          // value: `${v.id}-${level.id}`,
                        }))
                      )
                      .flat()}
                    state={formState.idiomasSelected}
                    getOptionValue={(option) => option.uid}
                    onChange={(v) => {
                      setFormState({ idiomasSelected: v });
                    }}
                    noOptionsMessage={() => {
                      return formState.idiomasError ? (
                        <FormattedMessage
                          id="mensagem.ocorreuErro"
                          defaultMessage="Ocorreu um erro"
                        />
                      ) : (
                        <FormattedMessage
                          id="info.carregando"
                          defaultMessage="Carregando..."
                        />
                      );
                    }}
                    placeholder={
                      <Text size="sm" fontColor={vars.color.lightForeground}>
                        <FormattedMessage
                          id="placeholder.idiomas"
                          defaultMessage="Ex.: inglês avançado, espanhol intermediário"
                        />
                      </Text>
                    }
                    shouldValidate={hasTriedToSubmit}
                  ></Multi>
                </>
              ) : (
                <>
                  <Text size="sm" as="p">
                    <span className={previewTagListStyle}>
                      {formState.idiomasSelected.map((v) => (
                        <span key={v.uid} className={previewTagStyle}>
                          {v.label}
                        </span>
                      ))}
                    </span>
                  </Text>
                </>
              )}
              <div className={separatorStyle}></div>
              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  <FormattedMessage
                    id="step1.titleSalario"
                    defaultMessage="Faixa salarial"
                  />
                }
                isEditing={isEditingSalario}
                setIsEditing={setIsEditingSalario}
                isLocked={formState.isSalarioLocked}
                setIsLocked={(v) => setFormState({ isSalarioLocked: v })}
                isVagaModelo={isVagaModelo}
                isLockNotAllowed={
                  formState.exibirSalario &&
                  (!formState.salarioFaixaValorInicial ||
                    !formState.salarioFaixaValorFinal)
                }
                invalid={
                  formState.salarioFaixaValorInicial >
                    formState.salarioFaixaValorFinal ||
                  (formState.exibirSalario &&
                    formState.salarioFaixaValorInicial < 1)
                }
                dataTestIdBtn="editar-salario"
                dataTestIdLock="bloquear-salario"
              />
              <Space height=".5rem" />
              {isEditingSalario ? (
                <Salario formState={formState} setFormState={setFormState} />
              ) : (
                <div className={rowStyle}>
                  <IconeDolar
                    fill={vars.color.foreground}
                    width={20}
                    height={20}
                  />
                  <Text size="sm" as="p">
                    {renderSalario()}
                  </Text>
                </div>
              )}
              <div className={separatorStyle}></div>
              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  <FormattedMessage
                    id="step1.titleBeneficios"
                    defaultMessage="Benefícios"
                  />
                }
                isEditing={isEditingBeneficios}
                setIsEditing={setIsEditingBeneficios}
                isLocked={formState.isBeneficiosLocked}
                setIsLocked={(v) => setFormState({ isBeneficiosLocked: v })}
                isVagaModelo={isVagaModelo}
                dataTestIdBtn="editar-beneficios"
                dataTestIdLock="bloquear-beneficios"
              />
              <Space height=".5rem" />
              {isEditingBeneficios ? (
                <>
                  <Multi
                    name="beneficios"
                    options={beneficiosCategorias?.map((v) => ({
                      ...v,
                      options: formState.beneficiosData?.filter(
                        (b) => b.categoria.id === v.id
                      ),
                    }))}
                    getOptionValue={(option) => option.id}
                    state={formState.beneficiosSelected}
                    onChange={(v) => {
                      setFormState({ beneficiosSelected: v });
                    }}
                    noOptionsMessage={() => {
                      return formState.beneficiosError ? (
                        <FormattedMessage
                          id="mensagem.ocorreuErro"
                          defaultMessage="Ocorreu um erro"
                        />
                      ) : (
                        <FormattedMessage
                          id="info.carregando"
                          defaultMessage="Carregando..."
                        />
                      );
                    }}
                    placeholder={
                      <Text size="sm" fontColor={vars.color.lightForeground}>
                        <FormattedMessage
                          id="placeholder.pesquiseSelecione"
                          defaultMessage="Pesquise e selecione"
                        />
                      </Text>
                    }
                    shouldValidate={hasTriedToSubmit}
                  ></Multi>

                  <div className={selectedBenefits}>
                    {formState.beneficiosSelected?.map((v) => (
                      <div className={benefitItemPreview} key={v.id}>
                        <IconesBeneficios
                          aria-hidden="true"
                          dangerouslySetInnerHTML={{
                            __html: v.imagem,
                          }}
                        />
                        <Text size="sm" as="p">
                          {v.label}
                        </Text>

                        {formState.beneficiosData?.find(
                          (beneficio) => beneficio.id === v.id
                        ).permite_valor ? (
                          <Input
                            type="number"
                            placeholder={intl.formatMessage(
                              defineMessage({
                                id: "step1.placeholderValorBeneficio",
                                defaultMessage: "R$ 0,00",
                              })
                            )}
                            variant="inline-value"
                            value={v.value ?? ""}
                            onChange={(e) =>
                              setFormState((prev) => ({
                                beneficiosSelected: prev.beneficiosSelected.map(
                                  (item) =>
                                    item.id === v.id
                                      ? { ...item, value: e.target.value }
                                      : item
                                ),
                              }))
                            }
                            data-testid={`valor-${v.id}`}
                            min={1}
                            errorMessage={
                              <FormattedMessage
                                id="step1.valorInválido"
                                defaultMessage="Valor inválido"
                              />
                            }
                            format="currency"
                            aria-label={`valor ${v.label}`}
                          />
                        ) : null}
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className={listBenefits}>
                  {formState.beneficiosSelected?.map((v) => (
                    <div className={benefitItem} key={v.id}>
                      <IconesBeneficios
                        aria-hidden="true"
                        dangerouslySetInnerHTML={{
                          __html: formState.beneficiosData?.find(
                            (b) => b.id === v.id
                          ).imagem,
                        }}
                      />
                      <Text size="sm" as="p">
                        {
                          formState.beneficiosData?.find((b) => b.id === v.id)
                            .label
                        }
                      </Text>

                      {v.value ? (
                        <Text size="xs" as="p">
                          {new Intl.NumberFormat("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          }).format(v.value)}
                        </Text>
                      ) : null}
                    </div>
                  ))}
                </div>
              )}

              <div className={separatorStyle}></div>

              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  isVagaModelo ? (
                    <FormattedMessage
                      id="step1.labelEscolaridadeOpcional"
                      defaultMessage={"Escolaridade mínima"}
                    />
                  ) : (
                    <FormattedMessage
                      id="step1.labelEscolaridadeObrigatoria"
                      defaultMessage={"Escolaridade mínima *"}
                    />
                  )
                }
                isEditing={isEditingEscolaridade}
                setIsEditing={setIsEditingEscolaridade}
                isLocked={formState.isEscolaridadeLocked}
                setIsLocked={(v) => setFormState({ isEscolaridadeLocked: v })}
                isVagaModelo={isVagaModelo}
                isLockNotAllowed={!formState.escolaridadeMinimaSelectedId}
                invalid={
                  !formState.escolaridadeMinimaSelectedId && !isVagaModelo
                }
                dataTestIdBtn="editar-escolaridade"
                dataTestIdLock="bloquear-escolaridade"
              />
              <Space height="0.5rem" />
              {isEditingEscolaridade ? (
                <>
                  <Select
                    value={formState.escolaridadeMinimaSelectedId}
                    onChange={(e) =>
                      setFormState({
                        escolaridadeMinimaSelectedId: Number(e.target.value),
                      })
                    }
                    required
                    shouldValidate={hasTriedToSubmit}
                    errorMessage={
                      <FormattedMessage
                        id="erro.campoObrigatorio"
                        defaultMessage="Campo obrigatório"
                      />
                    }
                    data-testid="select-escolaridade"
                  >
                    {renderSelectOptions({
                      data: formState.escolaridadeMinimaData,
                      error: formState.escolaridadeMinimaError,
                      errorMessage: intl.formatMessage(
                        defineMessage({
                          id: "select.erro",
                          defaultMessage: "Ocorreu um erro",
                        })
                      ),
                      loadingMessage: intl.formatMessage(
                        defineMessage({
                          id: "select.loading",
                          defaultMessage: "Carregando...",
                        })
                      ),
                      selectOptionMessage: intl.formatMessage(
                        defineMessage({
                          id: "select.escolherOpcao",
                          defaultMessage: "Selecione uma opção...",
                        })
                      ),
                    })}
                  </Select>
                </>
              ) : (
                <>
                  <Text size="sm" as="p">
                    <span className={previewTagStyle}>
                      {
                        formState.escolaridadeMinimaData?.find(
                          (v) => v.id == formState.escolaridadeMinimaSelectedId
                        )?.label
                      }
                    </span>
                  </Text>
                </>
              )}

              <div className={separatorStyle}></div>

              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  isVagaModelo ? (
                    <FormattedMessage
                      id="step1.nivelHierarquicoOpcional"
                      defaultMessage={"Nível hierárquico"}
                    />
                  ) : (
                    <FormattedMessage
                      id="step1.nivelHierarquicoObrigatorio"
                      defaultMessage={"Nível hierárquico *"}
                    />
                  )
                }
                isEditing={isEditingNivelHierarquico}
                setIsEditing={setIsEditingNivelHierarquico}
                isLocked={formState.isNivelHierarquicoLocked}
                setIsLocked={(v) =>
                  setFormState({ isNivelHierarquicoLocked: v })
                }
                isVagaModelo={isVagaModelo}
                isLockNotAllowed={!formState.nivelHierarquicoSelectedId}
                invalid={!formState.nivelHierarquicoSelectedId && !isVagaModelo}
                dataTestIdBtn="editar-nivel-hierarquico"
                dataTestIdLock="bloquear-nivel-hierarquico"
              />
              <Space height=".5rem" />
              {isEditingNivelHierarquico ? (
                <>
                  <Select
                    aria-label="Nível hierárquico"
                    placeholder={intl.formatMessage(
                      defineMessage({
                        id: "step1.placeholderNivel",
                        defaultMessage:
                          "Qual o nível você precisa? (Júnior, pleno, sênior...)",
                      })
                    )}
                    value={formState.nivelHierarquicoSelectedId}
                    onChange={(e) => {
                      setFormState({
                        nivelHierarquicoSelectedId: Number(e.target.value),
                      });
                      if (e.target.value === "28")
                        setFormState({ modeloContratacaoSelectedId: 2 });
                    }}
                    required={!isVagaModelo}
                    shouldValidate={hasTriedToSubmit}
                    errorMessage={
                      <FormattedMessage
                        id="erro.campoObrigatorio"
                        defaultMessage="Campo obrigatório"
                      />
                    }
                    data-testid="input-nivel-hierarquico"
                  >
                    {renderSelectOptions({
                      data: formState.niveisHierarquicosData,
                      error: formState.niveisHierarquicosError,
                      errorMessage: intl.formatMessage(
                        defineMessage({
                          id: "select.erro",
                          defaultMessage: "Ocorreu um erro",
                        })
                      ),
                      loadingMessage: intl.formatMessage(
                        defineMessage({
                          id: "select.loading",
                          defaultMessage: "Carregando...",
                        })
                      ),
                      selectOptionMessage: intl.formatMessage(
                        defineMessage({
                          id: "select.escolherOpcao",
                          defaultMessage: "Selecione uma opção...",
                        })
                      ),
                    })}
                  </Select>
                </>
              ) : (
                <div className={rowStyle}>
                  <IconeSpreadSheet
                    fill={vars.color.foreground}
                    width={20}
                    height={20}
                  />
                  <Text size="sm" as="p">
                    {
                      formState.niveisHierarquicosData?.find(
                        (v) => v.id == formState.nivelHierarquicoSelectedId
                      )?.label
                    }
                  </Text>
                </div>
              )}

              <div className={separatorStyle}></div>

              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  isVagaModelo ? (
                    <FormattedMessage
                      id="step1.labelTextAreasOpcional"
                      defaultMessage={"Áreas de atuação"}
                    />
                  ) : (
                    <FormattedMessage
                      id="step1.labelTextAreasObrigatorio"
                      defaultMessage={"Áreas de atuação *"}
                    />
                  )
                }
                isEditing={isEditingAreasAtuacao}
                setIsEditing={setIsEditingAreasAtuacao}
                isLocked={formState.isAreasAtuacaoLocked}
                setIsLocked={(v) => setFormState({ isAreasAtuacaoLocked: v })}
                isVagaModelo={isVagaModelo}
                isLockNotAllowed={!formState.areasAtuacaoSelected?.length}
                invalid={
                  !formState.areasAtuacaoSelected?.length && !isVagaModelo
                }
                dataTestIdBtn="editar-areas"
                dataTestIdLock="bloquear-areas"
              />
              <Space height="0.5rem" />
              {isEditingAreasAtuacao ? (
                <>
                  <Multi
                    name="areas"
                    options={
                      formState.areasAtuacaoSelected.length === limiteAreas
                        ? []
                        : formState.areasAtuacaoData
                    }
                    required={!isVagaModelo}
                    state={formState.areasAtuacaoSelected}
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => option.descricao}
                    onChange={(v) => {
                      setFormState({ areasAtuacaoSelected: v });
                    }}
                    noOptionsMessage={() => {
                      return formState.areasAtuacaoSelected.length ===
                        limiteAreas ? (
                        <FormattedMessage
                          id="step1-limiteAreas"
                          defaultMessage="Você atingiu o máximo de áreas"
                        />
                      ) : (
                        <FormattedMessage
                          id="mensagem.ocorreuErro"
                          defaultMessage="Ocorreu um erro"
                        />
                      );
                    }}
                    placeholder={
                      <Text size="sm" fontColor={vars.color.lightForeground}>
                        <FormattedMessage
                          id="placeholder.pesquiseSelecione"
                          defaultMessage="Pesquise e selecione"
                        />
                      </Text>
                    }
                    errorMessage={
                      <FormattedMessage
                        id="erro.campoObrigatorio"
                        defaultMessage="Campo obrigatório"
                      />
                    }
                    shouldValidate={hasTriedToSubmit}
                  ></Multi>
                </>
              ) : (
                <>
                  <span className={previewTagListStyle}>
                    {formState.areasAtuacaoSelected.map((v) => (
                      <Text size="sm" as="p">
                        <span className={previewTagStyle} key={v.id}>
                          {
                            formState.areasAtuacaoData?.find(
                              (b) => b.id === v.id
                            ).descricao
                          }
                        </span>
                      </Text>
                    ))}
                  </span>
                </>
              )}

              <div className={separatorStyle}></div>

              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  <FormattedMessage
                    id="step1.titleLocalizacao"
                    defaultMessage="Localização"
                  />
                }
                isEditing={isEditingLocal}
                setIsEditing={setIsEditingLocal}
                isLocked={formState.isLocalLocked}
                setIsLocked={(v) => setFormState({ isLocalLocked: v })}
                isVagaModelo={isVagaModelo}
                isLockNotAllowed={
                  !formState.enderecoQuery ||
                  !formState.localTrabalhoSelectedId ||
                  !formState.enderecoRestricao
                }
                invalid={
                  (!formState.enderecoQuery ||
                    !formState.localTrabalhoSelectedId ||
                    !formState.enderecoRestricao) &&
                  !isVagaModelo
                }
                dataTestIdBtn="editar-localizacao"
                dataTestIdLock="bloquear-localizacao"
              />
              <Space height=".5rem" />
              {isEditingLocal ? (
                <>
                  <Fieldset
                    title={
                      <FormattedMessage
                        id="step1.titleModeloDeTrabalho"
                        defaultMessage={
                          isVagaModelo
                            ? "Modelo de trabalho"
                            : "Modelo de trabalho *"
                        }
                      />
                    }
                    isValid={formState.localTrabalhoSelectedId}
                    shouldValidate={hasTriedToSubmit}
                    errorMessage={
                      <FormattedMessage
                        id="step1.erroInformeModeloTrabalho"
                        defaultMessage="Campo obrigatório. Selecione um modelo de trabalho."
                      />
                    }
                  >
                    <div style={{ display: "flex", direction: "row" }}>
                      {!formState.locaisTrabalhoData &&
                      formState.locaisTrabalhoError ? (
                        <Label
                          text={
                            <FormattedMessage
                              id="mensagem.ocorreuErro"
                              defaultMessage="Ocorreu um erro"
                            />
                          }
                        />
                      ) : (
                        formState.locaisTrabalhoData?.map((item) => (
                          <React.Fragment key={`${item.id}-${item.tipo}`}>
                            <RadioButton
                              label={
                                <FormattedMessage
                                  id={`step1.${item.id}-${item.tipo}`}
                                  defaultMessage={item.nome}
                                />
                              }
                              id="modelo-de-trabalho"
                              name="modeloTrabalho"
                              value={item.id}
                              checked={
                                formState.localTrabalhoSelectedId === item.id
                              }
                              onChange={(e) =>
                                setFormState({
                                  localTrabalhoSelectedId: Number(
                                    e.target.value
                                  ),
                                })
                              }
                              required={!isVagaModelo}
                              data-testid="radio-modelo_trabalho"
                            />
                            <Space />
                          </React.Fragment>
                        ))
                      )}
                    </div>
                  </Fieldset>

                  <Space height=".5rem" />

                  <Input
                    label={
                      <FormattedMessage
                        id="step1.labelInformeEndereco"
                        defaultMessage={
                          isVagaModelo
                            ? "Local de trabalho"
                            : "Local de trabalho *"
                        }
                      />
                    }
                    ref={addressFieldRef}
                    type="text"
                    placeholder={intl.formatMessage(
                      defineMessage({
                        id: "step1.placeholderLocal",
                        defaultMessage: "Informe um endereço, cidade ou estado",
                      })
                    )}
                    autoComplete="off"
                    required
                    shouldValidate={hasTriedToSubmit}
                    errorMessage={
                      <FormattedMessage
                        id="step1.erroInformeLocal"
                        defaultMessage="Campo obrigatório. Selecione um local da lista."
                      />
                    }
                    data-testid="input-endereco"
                    value={formState.enderecoQuery}
                    onChange={(e) =>
                      setFormState({ enderecoQuery: e.target.value })
                    }
                    validate={(isValidInternally) => {
                      return isValidInternally && formState.enderecoFormatado;
                    }}
                  />

                  <Space height=".5rem" />

                  <Fieldset
                    title={
                      <FormattedMessage
                        id="step1.titleRestricaoProfissionaisCandidatura"
                        defaultMessage={
                          isVagaModelo
                            ? "Aceitar candidaturas:"
                            : "Aceitar candidaturas: *"
                        }
                      />
                    }
                    isValid={formState.enderecoRestricao}
                    shouldValidate={hasTriedToSubmit}
                    errorMessage={
                      <FormattedMessage
                        id="erro.campoObrigatorio"
                        defaultMessage="Campo obrigatório"
                      />
                    }
                  >
                    <RadioButton
                      label={
                        <FormattedMessage
                          id="step1.radioCidade"
                          defaultMessage="Apenas da cidade {cidade}"
                          values={{
                            cidade: formState.enderecoApiCidade,
                          }}
                        />
                      }
                      name="enderecoRestricao"
                      value="somente_cidade"
                      checked={formState.enderecoRestricao === "somente_cidade"}
                      onChange={(e) =>
                        setFormState({ enderecoRestricao: e.target.value })
                      }
                      disabled={!formState.enderecoApiCidade}
                      required
                      data-testid="radio-somente_cidade"
                    />
                    <RadioButton
                      label={
                        <FormattedMessage
                          id="step1.radioEstado"
                          defaultMessage="Apenas do estado {estado}"
                          values={{
                            estado: formState.enderecoApiEstado,
                          }}
                        />
                      }
                      name="enderecoRestricao"
                      value="somente_estado"
                      checked={formState.enderecoRestricao === "somente_estado"}
                      onChange={(e) =>
                        setFormState({ enderecoRestricao: e.target.value })
                      }
                      disabled={!formState.enderecoApiEstado}
                      data-testid="radio-somente_estado"
                    />
                    <RadioButton
                      label={
                        <FormattedMessage
                          id="step1.radioPais"
                          defaultMessage="Apenas do país {pais}"
                          values={{
                            pais: formState.enderecoApiPais,
                          }}
                        />
                      }
                      name="enderecoRestricao"
                      value="somente_pais"
                      checked={formState.enderecoRestricao === "somente_pais"}
                      onChange={(e) =>
                        setFormState({ enderecoRestricao: e.target.value })
                      }
                      disabled={!formState.enderecoApiPais}
                      data-testid="radio-somente_pais"
                    />
                    <RadioButton
                      label={
                        <FormattedMessage
                          id="step1.radioSemRestricoes"
                          defaultMessage="Sem restrições"
                        />
                      }
                      name="enderecoRestricao"
                      value="todas_localidades"
                      checked={
                        formState.enderecoRestricao === "todas_localidades"
                      }
                      onChange={(e) =>
                        setFormState({ enderecoRestricao: e.target.value })
                      }
                      data-testid="radio-sem-restricoes"
                    />
                  </Fieldset>
                </>
              ) : (
                <>
                  <div className={rowStyle}>
                    <IconeMapa
                      fill={vars.color.foreground}
                      width={20}
                      height={20}
                    />
                    <Text size="sm" as="p">
                      {renderLocal()}
                    </Text>
                    <Text size="sm" as="p">
                      <FormattedMessage
                        id="step4.localTrabalho"
                        defaultMessage="Local de Trabalho: "
                      />
                      {
                        formState.locaisTrabalhoData?.find(
                          (v) => v.id == formState.localTrabalhoSelectedId
                        )?.nome
                      }
                    </Text>
                  </div>
                </>
              )}

              <div className={separatorStyle}></div>

              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  isVagaModelo ? (
                    <FormattedMessage
                      id="step1.titleSobreEmpresaOpcional"
                      defaultMessage={"Sobre a empresa"}
                    />
                  ) : (
                    <FormattedMessage
                      id="step1.titleSobreEmpresaObrigatorio"
                      defaultMessage={"Sobre a empresa *"}
                    />
                  )
                }
                isEditing={isEditingApresentacaoEmpresa}
                setIsEditing={setIsEditingApresentacaoEmpresa}
                isLocked={formState.isApresentacaoEmpresaLocked}
                setIsLocked={(v) =>
                  setFormState({ isApresentacaoEmpresaLocked: v })
                }
                isVagaModelo={isVagaModelo}
                isLockNotAllowed={
                  formState.isAnuncioConfidencial === null ||
                  (formState.isAnuncioConfidencial === false &&
                    (formState.tipoApresentacao === null ||
                      (formState.tipoApresentacao === "utilizando-modelo" &&
                        !formState.apresentacaoId) ||
                      (formState.tipoApresentacao === "criando-modelo" &&
                        (!formState.apresentacaoNomeModelo ||
                          !formState.apresentacaoNomeEmpresa ||
                          !formState.apresentacaoDescricao))))
                }
                invalid={
                  !isVagaModelo &&
                  (formState.isAnuncioConfidencial === null ||
                    (formState.isAnuncioConfidencial === false &&
                      (formState.tipoApresentacao === null ||
                        (formState.tipoApresentacao === "utilizando-modelo" &&
                          !formState.apresentacaoId) ||
                        (formState.tipoApresentacao === "criando-modelo" &&
                          (!formState.apresentacaoNomeModelo ||
                            !formState.apresentacaoNomeEmpresa ||
                            !formState.apresentacaoDescricao)))))
                }
                dataTestIdBtn="editar-apresentacao"
                dataTestIdLock="bloquear-apresentacao"
              />
              <Space height=".5rem" />
              {isEditingApresentacaoEmpresa ? (
                <FieldsetSobreEmpresa
                  formState={formState}
                  setFormState={setFormState}
                  isVagaModelo={isVagaModelo}
                  hasTriedToSubmit={hasTriedToSubmit}
                />
              ) : (
                <>
                  <div>
                    {formState.isAnuncioConfidencial === false ? (
                      <img
                        className={previewLogoStyle}
                        src={
                          formState.apresentacoesEmpresaData?.find(
                            (v) => v.id == formState.apresentacaoId
                          )?.logotipo
                        }
                        alt="logotipo da empresa"
                      ></img>
                    ) : null}
                    {formState.isAnuncioConfidencial === true ? (
                      <>
                        <Space height="1rem" />
                        <div className={previewLogoStyle}>
                          <IlustracaoPredio />
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div>
                    <Text size="sm" as="p" weight={600}>
                      {formState.isAnuncioConfidencial === false
                        ? formState.apresentacoesEmpresaData?.find(
                            (v) => v.id == formState.apresentacaoId
                          )?.nome_empresa
                        : null}
                      {formState.isAnuncioConfidencial === true ? (
                        <Text size="sm" weight={600}>
                          <FormattedMessage
                            id="step4.anuncioConfidencial"
                            defaultMessage="Anúncio confidencial"
                          />
                        </Text>
                      ) : null}
                    </Text>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: formState.apresentacoesEmpresaData?.find(
                          (v) => v.id == formState.apresentacaoId
                        )?.descricao,
                      }}
                    ></div>
                  </div>
                </>
              )}
            </FormCard>

            <Space height=".5rem" />

            <FormCard
              title={
                <FormattedMessage id="step4.gestao" defaultMessage="Gestão" />
              }
            >
              {!isVagaModelo &&
              formState.painelData?.funcionario.admin === true ? (
                <>
                  <EditLock
                    isFromVagaModelo={isFromVagaModelo}
                    title={
                      <FormattedMessage
                        id="step3.responsavel"
                        defaultMessage="Responsável pela vaga *"
                      />
                    }
                    isEditing={isEditingResponsavel}
                    setIsEditing={setIsEditingResponsavel}
                    invalid={!formState.responsavelSelectedId}
                    dataTestIdBtn="editar-responsavel"
                    dataTestIdLock="bloquear-responsavel"
                  />

                  <Space height=".5rem" />

                  {isEditingResponsavel ? (
                    <Select
                      value={formState.responsavelSelectedId}
                      onChange={(e) =>
                        setFormState({
                          responsavelSelectedId: Number(e.target.value),
                        })
                      }
                      required
                      shouldValidate={hasTriedToSubmit}
                      errorMessage={
                        <FormattedMessage
                          id="erro.campoObrigatorio"
                          defaultMessage="Campo obrigatório"
                        />
                      }
                      data-testid="select-responsavel"
                    >
                      {renderSelectOptions({
                        data: formState.responsavelData.sort((a, b) =>
                          a.nome.localeCompare(b.nome)
                        ),
                        error: formState.responsavelError,
                        labelKey: "nome",
                        errorMessage: intl.formatMessage(
                          defineMessage({
                            id: "select.erro",
                            defaultMessage: "Ocorreu um erro",
                          })
                        ),
                        loadingMessage: intl.formatMessage(
                          defineMessage({
                            id: "select.loading",
                            defaultMessage: "Carregando...",
                          })
                        ),
                        selectOptionMessage: intl.formatMessage(
                          defineMessage({
                            id: "select.escolherOpcao",
                            defaultMessage: "Selecione uma opção...",
                          })
                        ),
                      })}
                    </Select>
                  ) : (
                    <>
                      <Text size="sm" as="p">
                        {
                          formState.responsavelData?.find(
                            (v) => v.id == formState.responsavelSelectedId
                          )?.nome
                        }
                      </Text>
                    </>
                  )}
                </>
              ) : null}
              {(!isVagaModelo &&
                formState.subdivisoesData?.length > 1 &&
                formState.painelData?.funcionario.admin === true) ||
              formState.painelData?.funcionario.permissoes
                .dir_compartilhar_vaga === true ? (
                <>
                  <div className={separatorStyle}></div>

                  <EditLock
                    isFromVagaModelo={isFromVagaModelo}
                    title={
                      <FormattedMessage
                        id="step3.subdivisoes"
                        defaultMessage="Permissão de acesso a outras áreas (subdivisões) da empresa"
                      />
                    }
                    isEditing={isEditingSubdivisoes}
                    setIsEditing={setIsEditingSubdivisoes}
                    dataTestIdBtn="editar-subdivisoes"
                    dataTestIdLock="bloquear-subdivisoes"
                  />

                  <Space height=".5rem" />

                  {isEditingSubdivisoes ? (
                    <Multi
                      name="subdivisoes"
                      options={formState.subdivisoesData?.map((v) => ({
                        ...v,
                        label: `${v.label_divisao} - ${v.label}`,
                      }))}
                      state={formState.subdivisoesSelected}
                      onChange={(v) => {
                        setFormState({ subdivisoesSelected: v });
                      }}
                      getOptionValue={(option) => option.id}
                      noOptionsMessage={() => {
                        return formState.subdivisoesError ? (
                          <FormattedMessage
                            id="mensagem.ocorreuErro"
                            defaultMessage="Ocorreu um erro"
                          />
                        ) : (
                          <FormattedMessage
                            id="step1-limiteOpcoes"
                            defaultMessage="Não há mais opções disponíveis."
                          />
                        );
                      }}
                      placeholder={
                        <Text size="sm" fontColor={vars.color.lightForeground}>
                          <FormattedMessage
                            id="placeholder.pesquiseSelecione"
                            defaultMessage="Pesquise e selecione"
                          />
                        </Text>
                      }
                      data-testid="select-subdivisoes"
                    ></Multi>
                  ) : (
                    <>
                      {formState.subdivisoesSelected
                        .filter((v) => v.id)
                        .map((v) => {
                          const subdivisao = {
                            ...v,
                            ...formState.subdivisoesData?.find(
                              (f) => f.id == f.subdivisoesSelected
                            ),
                          };
                          return (
                            <div key={v.id}>
                              <Text size="sm" as="p">
                                {subdivisao.label}
                              </Text>
                            </div>
                          );
                        })}
                    </>
                  )}
                </>
              ) : null}

              <div className={separatorStyle}></div>

              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  isVagaModelo ? (
                    <FormattedMessage
                      id="step4.titleFasesOpcional"
                      defaultMessage="Etapas do processo seletivo"
                    />
                  ) : (
                    <FormattedMessage
                      id="step4.titleFasesObrigatorio"
                      defaultMessage="Etapas do processo seletivo *"
                    />
                  )
                }
                isEditing={isEditingFases}
                setIsEditing={setIsEditingFases}
                isLocked={formState.isFasesLocked}
                setIsLocked={(v) => setFormState({ isFasesLocked: v })}
                isVagaModelo={isVagaModelo}
                isLockNotAllowed={!formState.fasesSelected?.length}
                invalid={!isVagaModelo && !formState.fasesSelected?.length}
                dataTestIdBtn="editar-fases"
                dataTestIdLock="bloquear-fases"
              />
              <Space height={"0.5rem"} />

              {isEditingFases ? (
                <>
                  <Multi
                    name="fases"
                    options={formState.fasesData}
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => option.nome}
                    required={!isVagaModelo}
                    state={formState.fasesSelected.sort(
                      (a, b) => a.ordem - b.ordem
                    )}
                    onChange={(v) => {
                      setFormState({ fasesSelected: v });
                    }}
                    noOptionsMessage={() => {
                      return formState.fasesError ? (
                        <FormattedMessage
                          id="mensagem.ocorreuErro"
                          defaultMessage="Ocorreu um erro"
                        />
                      ) : (
                        <FormattedMessage
                          id="step1-limiteOpcoes"
                          defaultMessage="Não há mais opções disponíveis."
                        />
                      );
                    }}
                    placeholder={
                      <Text size="sm" fontColor={vars.color.lightForeground}>
                        <FormattedMessage
                          id="placeholder.selecioneProcessoSeletivo"
                          defaultMessage="Selecione as etapas do seu processo seletivo"
                        />
                      </Text>
                    }
                    errorMessage={
                      <FormattedMessage
                        id="erro.campoObrigatorio"
                        defaultMessage="Campo obrigatório"
                      />
                    }
                    shouldValidate={hasTriedToSubmit}
                  ></Multi>

                  <Space height="1rem" />

                  <div
                    style={{
                      display: "flex",
                      overflow: "auto",
                      overflowWrap: "break-word",
                    }}
                  >
                    {formState.fasesSelected?.map((fase, index) => (
                      <React.Fragment key={fase.id}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            maxWidth: "200px",
                            textAlign: "left",
                          }}
                        >
                          <span
                            className={`${circle} ${circleVariant["base"]}`}
                          >
                            {index + 1}
                          </span>
                          <Text size="sm" as="span">
                            {fase.nome}
                          </Text>
                        </div>
                        {index < formState.fasesSelected.length - 1 ? (
                          <div
                            className={`${divider} ${dividerVariant["base"]}`}
                          ></div>
                        ) : null}
                      </React.Fragment>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <Text size="sm" as="p">
                    <span className={previewTagListStyle}>
                      {formState.fasesSelected
                        .sort((a, b) => a.ordem - b.ordem)
                        .map((v) => (
                          <span key={v.id} className={previewTagStyle}>
                            {v.nome}
                          </span>
                        ))}
                    </span>
                  </Text>
                  <Space height="1rem" />

                  <div
                    style={{
                      display: "flex",
                      overflow: "auto",
                      overflowWrap: "break-word",
                    }}
                  >
                    {formState.fasesSelected?.map((fase, index) => (
                      <React.Fragment key={fase.id}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            maxWidth: "200px",
                            textAlign: "left",
                          }}
                        >
                          <span
                            className={`${circle} ${circleVariant["base"]}`}
                          >
                            {index + 1}
                          </span>
                          <Text size="sm" as="span">
                            {fase.nome}
                          </Text>
                        </div>
                        {index < formState.fasesSelected.length - 1 ? (
                          <div
                            className={`${divider} ${dividerVariant["base"]}`}
                          ></div>
                        ) : null}
                      </React.Fragment>
                    ))}
                  </div>
                </>
              )}

              <div className={separatorStyle}></div>

              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  <FormattedMessage
                    id="step2.titleParceiros"
                    defaultMessage="Parceiros"
                  />
                }
                isEditing={isEditingParceiros}
                setIsEditing={setIsEditingParceiros}
                isLocked={formState.isParceirosLocked}
                setIsLocked={(v) => setFormState({ isParceirosLocked: v })}
                isVagaModelo={isVagaModelo}
                dataTestIdBtn="editar-parceiros"
                dataTestIdLock="bloquear-parceiros"
              />

              {isEditingParceiros ? (
                renderParceiros()
              ) : (
                <>
                  {formState.isParceiroEtalentSelecionado ? (
                    <>
                      <Space height={"1rem"} />
                      <div className={rowStyle}>
                        <LogoEtalent />
                        <Text as="p" size="sm">
                          {
                            <FormattedMessage
                              id="step2.etalent"
                              defaultMessage="VAGAS ETALENT - Análise DISC"
                            />
                          }
                        </Text>
                      </div>
                    </>
                  ) : null}
                </>
              )}

              <div className={separatorStyle}></div>

              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  <FormattedMessage
                    id="step2.fichasTestes"
                    defaultMessage="Fichas e testes"
                  />
                }
                isEditing={isEditingFichas}
                setIsEditing={setIsEditingFichas}
                isLocked={formState.isFichasLocked}
                setIsLocked={(v) => setFormState({ isFichasLocked: v })}
                isVagaModelo={isVagaModelo}
                dataTestIdBtn="editar-fichas"
                dataTestIdLock="bloquear-fichas"
              />

              <Space height=".5rem" />

              {isEditingFichas ? (
                <>
                  {formState.fichasSelected.map((currentSelect, index) => (
                    <div key={currentSelect.uid}>
                      {index >= 1 ? <Space /> : null}
                      <div className={wrapperAdicionarRemoverFichas}>
                        <Select
                          aria-label="Fichas e testes"
                          className={selectFichasStyle}
                          value={currentSelect.fichaSelecionadaId}
                          onChange={(e) => {
                            if (Number(e.target.value) === 0) {
                              setFormState((prev) => ({
                                fichasSelected: prev.fichasSelected.map((v) => {
                                  if (v.uid === currentSelect.uid)
                                    return {
                                      ...v,
                                      isPreenchimentoObrigatorio: false,
                                    };

                                  return v;
                                }),
                              }));
                            }
                            setFormState((prev) => ({
                              fichasSelected: prev.fichasSelected.map((v) => {
                                if (v.uid === currentSelect.uid)
                                  return {
                                    ...v,
                                    fichaSelecionadaId: Number(e.target.value),
                                  };
                                return v;
                              }),
                            }));
                          }}
                          data-testid="select-fichas"
                        >
                          {renderFichasSelectOptions(
                            currentSelect.fichaSelecionadaId
                          )}
                        </Select>

                        {index === formState.fichasSelected?.length - 1 ? (
                          <button
                            type="button"
                            className={btnAdicionarRemoverStyle}
                            disabled={
                              formState.fichasSelected.length >= 4 ||
                              !currentSelect.fichaSelecionadaId
                            }
                            onClick={() =>
                              setFormState((prev) => ({
                                fichasSelected: [
                                  ...prev.fichasSelected,
                                  {
                                    uid: uid(),
                                    fichaSelecionadaId: "",
                                    isPreenchimentoObrigatorio: false,
                                  },
                                ],
                              }))
                            }
                            aria-label="adicionar ficha"
                          >
                            <IconPlusCircle />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className={btnAdicionarRemoverStyle}
                            disabled={formState.fichasSelected?.length <= 1}
                            onClick={() =>
                              setFormState((prev) => ({
                                fichasSelected: prev.fichasSelected.filter(
                                  (v) => v.uid !== currentSelect.uid
                                ),
                              }))
                            }
                            aria-label="remover ficha"
                          >
                            <IconMinusCircle />
                          </button>
                        )}
                      </div>

                      {currentSelect.fichaSelecionadaId ? (
                        <>
                          <Space height=".5rem" />

                          <Checkbox
                            label={
                              <FormattedMessage
                                id="step2.preenchimentoObrigatorio"
                                defaultMessage="Preenchimento obrigatório"
                              />
                            }
                            checked={currentSelect.isPreenchimentoObrigatorio}
                            onChange={(e) =>
                              setFormState((prev) => ({
                                fichasSelected: prev.fichasSelected.map((v) => {
                                  if (v.uid === currentSelect.uid)
                                    return {
                                      ...v,
                                      isPreenchimentoObrigatorio:
                                        e.target.checked,
                                    };

                                  return v;
                                }),
                              }))
                            }
                          />
                        </>
                      ) : null}
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {" "}
                  {formState.fichasSelected
                    .filter((v) => v.fichaSelecionadaId)
                    .map((v) => {
                      const ficha = {
                        ...v,
                        ...formState.fichasData?.find(
                          (u) => u.id == v.fichaSelecionadaId
                        ),
                      };
                      return (
                        <div className={rowStyle} key={v.fichaSelecionadaId}>
                          <IconeFile
                            width={20}
                            height={18}
                            fill={vars.color.foreground}
                          />
                          <Text size="sm" as="p">
                            {ficha?.label}
                          </Text>
                          {ficha?.isPreenchimentoObrigatorio ? (
                            <Text
                              size="sm"
                              fontColor={vars.color.lightForeground}
                            >
                              <FormattedMessage
                                id="step4.preenchimentoObrigatorio"
                                defaultMessage="- Preenchimento obrigatório"
                              />
                            </Text>
                          ) : (
                            <Text
                              size="sm"
                              as="p"
                              fontColor={vars.color.lightForeground}
                            >
                              <FormattedMessage
                                id="step4.preenchimentoOpcional"
                                defaultMessage="- Preenchimento opcional"
                              />
                            </Text>
                          )}
                        </div>
                      );
                    })}
                </>
              )}

              <div className={separatorStyle}></div>

              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  <FormattedMessage
                    id="step2.titleComunicacaoCandidato"
                    defaultMessage="Feedbacks automáticos"
                  />
                }
                isEditing={isEditingEnviarEmail}
                setIsEditing={setIsEditingEnviarEmail}
                isLocked={formState.isEnviarEmailLocked}
                setIsLocked={(v) => setFormState({ isEnviarEmailLocked: v })}
                isVagaModelo={isVagaModelo}
                invalid={formState.isEnviarEmail && !emailMensagemTextLength}
                dataTestIdBtn="editar-email"
                dataTestIdLock="bloquear-email"
              />

              {isEditingEnviarEmail ? (
                <>
                  <Space height=".5rem" />
                  <Checkbox
                    label={
                      <FormattedMessage
                        id="step2.enviarMensagem"
                        defaultMessage="Enviar mensagem"
                      />
                    }
                    checked={formState.isEnviarEmail}
                    onChange={(e) => {
                      if (!e.target.checked) {
                        setFormState({
                          emailRemetente: "",
                          emailMensagem: "",
                          modeloEmailSelectedId: "",
                          isExibirRemetente: false,
                        });
                      }
                      setFormState({ isEnviarEmail: e.target.checked });
                    }}
                    data-testid="checkbox-enviar-mensagem"
                  />

                  {formState.isEnviarEmail ? (
                    <>
                      <Space height=".5rem" />

                      {formState.modelosEmailData.length ? (
                        <>
                          <Select
                            label={
                              <FormattedMessage
                                id="step2.modeloMensagem"
                                defaultMessage="Modelos de mensagens"
                              />
                            }
                            value={formState.modeloEmailSelectedId}
                            onChange={(e) => {
                              const modeloEmailSelectedId = Number(
                                e.target.value
                              );
                              if (modeloEmailSelectedId) {
                                const mensagem =
                                  formState.modelosEmailData?.find(
                                    (v) => v.id === modeloEmailSelectedId
                                  );
                                setFormState({
                                  emailMensagem: mensagem.html,
                                });
                              }
                              if (modeloEmailSelectedId === 0) {
                                setFormState({ emailMensagem: "" });
                              }
                              setFormState({
                                modeloEmailSelectedId,
                              });
                            }}
                          >
                            {renderSelectOptions({
                              data: formState.modelosEmailData,
                              error: formState.modelosEmailError,
                              errorMessage: intl.formatMessage(
                                defineMessage({
                                  id: "select.erro",
                                  defaultMessage: "Ocorreu um erro",
                                })
                              ),
                              loadingMessage: intl.formatMessage(
                                defineMessage({
                                  id: "select.loading",
                                  defaultMessage: "Carregando...",
                                })
                              ),
                              selectOptionMessage: intl.formatMessage(
                                defineMessage({
                                  id: "select.escolherOpcao",
                                  defaultMessage: "Selecione uma opção...",
                                })
                              ),
                            })}
                          </Select>
                          <Space />
                        </>
                      ) : null}

                      <TextEditor
                        label={
                          <FormattedMessage
                            id="step2.mensagem"
                            defaultMessage="Mensagem"
                          />
                        }
                        value={formState.emailMensagem}
                        onChange={(e) => setFormState({ emailMensagem: e })}
                        isValid={
                          formState.isEnviarEmail && emailMensagemTextLength
                        }
                        shouldValidate={hasTriedToSubmit}
                        errorMessage="Campo obrigatório"
                        isImageHidden
                        isVideoHidden
                        length={emailMensagemTextLength}
                      />
                    </>
                  ) : null}
                </>
              ) : (
                <>
                  <Space height=".5rem" />
                  {formState.isEnviarEmail ? (
                    <>
                      <Text size="sm" as="div">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: formState.emailMensagem,
                          }}
                        ></div>
                      </Text>
                    </>
                  ) : (
                    <>
                      <Text size="sm" as="p">
                        <FormattedMessage
                          id="step4.naoEnviarEmail"
                          defaultMessage="Não enviar e-mail"
                        />
                      </Text>
                    </>
                  )}
                </>
              )}

              {formState.isEnviarEmail ? (
                <>
                  <div className={separatorStyle}></div>
                  <EditLock
                    isFromVagaModelo={isFromVagaModelo}
                    text={
                      <FormattedMessage
                        id="step2.nomeRemetente"
                        defaultMessage="Nome remetente"
                      />
                    }
                    isEditing={isEditingExibirRemetente}
                    setIsEditing={setIsEditingExibirRemetente}
                    isLocked={formState.isExibirRemetenteLocked}
                    setIsLocked={(v) =>
                      setFormState({ isExibirRemetenteLocked: v })
                    }
                    isVagaModelo={isVagaModelo}
                    invalid={
                      formState.isExibirRemetente &&
                      (!formState.nomeRemetente || !formState.emailRemetente)
                    }
                    dataTestIdBtn="editar-remetente"
                    dataTestIdLock="bloquear-remetente"
                  />

                  {isEditingExibirRemetente ? (
                    <>
                      <Space height={".5rem"} />
                      <Checkbox
                        label="Exibir remetente"
                        checked={formState.isExibirRemetente}
                        onChange={(e) =>
                          setFormState({
                            isExibirRemetente: e.target.checked,
                          })
                        }
                      />

                      {formState.isExibirRemetente ? (
                        <>
                          <Label
                            text={
                              <FormattedMessage
                                id="step2.nomeRemetente"
                                defaultMessage="Nome remetente"
                              />
                            }
                          >
                            <Input
                              type="nome"
                              value={formState.nomeRemetente}
                              onChange={(e) =>
                                setFormState({ nomeRemetente: e.target.value })
                              }
                              required={!formState.isExibirRemetente}
                              shouldValidate={hasTriedToSubmit}
                              errorMessage="Campo obrigatório"
                            />
                          </Label>

                          <Space />

                          <Label
                            text={
                              <FormattedMessage
                                id="step2.emailRemetente"
                                defaultMessage="E-mail remetente"
                              />
                            }
                          >
                            <Input
                              type="email"
                              value={formState.emailRemetente}
                              onChange={(e) =>
                                setFormState({ emailRemetente: e.target.value })
                              }
                              required={!formState.isExibirRemetente}
                              shouldValidate={hasTriedToSubmit}
                              errorMessage={
                                <FormattedMessage
                                  id="erro.campoObrigatorio"
                                  defaultMessage="Campo obrigatório"
                                />
                              }
                            />
                          </Label>
                        </>
                      ) : null}
                    </>
                  ) : (
                    <>
                      {formState.isExibirRemetente ? (
                        <>
                          <Text
                            as="p"
                            size="sm"
                            fontColor={vars.color.lightForeground}
                          >
                            {formState.nomeRemetente}
                          </Text>

                          <Text
                            as="p"
                            size="sm"
                            fontColor={vars.color.lightForeground}
                          >
                            {formState.emailRemetente}
                          </Text>
                        </>
                      ) : (
                        <Text size="sm" as="p">
                          <FormattedMessage
                            id="step4.naoExibirRemetente"
                            defaultMessage="Não exibir remetente"
                          />
                        </Text>
                      )}
                    </>
                  )}
                </>
              ) : null}

              <div className={separatorStyle}></div>

              <EditLock
                isFromVagaModelo={isFromVagaModelo}
                title={
                  <FormattedMessage
                    id="step2.titleIndicacao"
                    defaultMessage="Indicação de profissionais"
                    description="Está relacionado a indicar alguém para ocupar um cargo"
                  />
                }
                isEditing={isEditingIndicacao}
                setIsEditing={setIsEditingIndicacao}
                isLocked={formState.isIndicacaoLocked}
                setIsLocked={(v) => setFormState({ isIndicacaoLocked: v })}
                isVagaModelo={isVagaModelo}
                dataTestIdBtn="editar-indicacao"
                dataTestIdLock="bloquear-indicacao"
              />

              <div className={rowStyle}></div>

              {isEditingIndicacao ? (
                <>
                  <Space height=".5rem" />
                  <Checkbox
                    label={
                      <FormattedMessage
                        id="step2.aceitarIdicacao"
                        defaultMessage="Aceitar indicações"
                      />
                    }
                    checked={formState.isIndicacaoSelecionada}
                    onChange={(e) =>
                      setFormState({ isIndicacaoSelecionada: e.target.checked })
                    }
                    data-testid="checkbox-indicacoes"
                  />
                  {formState.isIndicacaoSelecionada ? (
                    <>
                      <Space height=".5rem" />

                      <Fieldset
                        isValid={!formState.isIndicacaoSelecionada}
                        shouldValidate={hasTriedToSubmit}
                        errorMessage={
                          <FormattedMessage
                            id="erro.campoObrigatorio"
                            defaultMessage="Campo obrigatório"
                          />
                        }
                      >
                        <RadioButton
                          label={
                            <FormattedMessage
                              id="step2.indicacaoQualquerPessoa"
                              defaultMessage="De qualquer pessoa/e-mail"
                              description="O contexto da frase é: Aceita indicações de qualquer pessoa"
                            />
                          }
                          name="tipo-indicacao"
                          value="indicacao-livre"
                          checked={
                            formState.tipoIndicacao === "indicacao-livre"
                          }
                          onChange={(e) =>
                            setFormState({ tipoIndicacao: e.target.value })
                          }
                          data-testid="indicacao-livre"
                          required
                        />
                        <RadioButton
                          label={
                            <FormattedMessage
                              id="step2.indicacaoRestricao"
                              defaultMessage="Somente de e-mails ou domínios abaixo:"
                              description="O contexto da frase é: Aceita indicações somente com restrição de e-mails ou domínios"
                            />
                          }
                          name="tipo-indicacao"
                          value="indicacao-restrita"
                          checked={
                            formState.tipoIndicacao === "indicacao-restrita"
                          }
                          onChange={(e) =>
                            setFormState({ tipoIndicacao: e.target.value })
                          }
                          data-testid="indicacao-restrita"
                        />
                      </Fieldset>
                      {formState.tipoIndicacao === "indicacao-restrita" ? (
                        <>
                          {renderEmailsIndicacao()}
                          <Space />
                          <Button
                            className={`${primaryButton} ${inputVariants["form-buttons"]}`}
                            type="submit"
                            onClick={() => handleEmailsIndicacaoSubmit()}
                            data-testid="btn-salvar-apresentacao"
                            disabled={
                              isEmailsPostPending ||
                              formState.emailsIndicacaoData ===
                                formState.emailsIndicacao ||
                              !formState.emailsIndicacao.length
                            }
                          >
                            {isPostPending ? (
                              <Spinner colorVariant="light" />
                            ) : (
                              <FormattedMessage
                                id="botao.salvar"
                                defaultMessage="Salvar"
                              />
                            )}
                          </Button>
                        </>
                      ) : null}
                    </>
                  ) : null}
                </>
              ) : (
                <>
                  {formState.isIndicacaoSelecionada &&
                  formState.tipoIndicacao === "indicacao-livre" ? (
                    <>
                      <Space height=".5rem" />

                      <div className={rowStyle}>
                        <IconeEnvelope
                          width="20"
                          height="18"
                          fill={vars.color.foreground}
                        />

                        <Text as="p" size="sm">
                          <FormattedMessage
                            id="step4.aceitaIndicacoes"
                            defaultMessage="Aceita indicações"
                          />
                        </Text>
                      </div>
                    </>
                  ) : null}

                  {formState.isIndicacaoSelecionada &&
                  formState.tipoIndicacao === "indicacao-restrita" &&
                  formState.emailsIndicacao?.length ? (
                    <>
                      <Space height=".5rem" />
                      <div className={rowStyle}>
                        <IconeEnvelope
                          width="20"
                          height="18"
                          fill={vars.color.foreground}
                        />
                        <Text as="p" size="sm">
                          <FormattedMessage
                            id="step4.aceitaIndicacoesRestricao"
                            defaultMessage="Aceita indicações com restrição de e-mails:"
                          />
                        </Text>
                      </div>
                      <Space height=".5rem" />

                      <span className={previewTagListStyle}>
                        {formState.emailsIndicacao.map((v) => (
                          <span className={previewTagStyle} key={v.id}>
                            <Text as="span" size="sm">
                              {v}
                            </Text>
                          </span>
                        ))}
                      </span>
                    </>
                  ) : null}
                </>
              )}
            </FormCard>

            <FormCard
              title={
                <FormattedMessage
                  id="step4.divulgacao"
                  defaultMessage="Divulgação"
                />
              }
            >
              {!isVagaModelo ? (
                <>
                  <EditLock
                    isFromVagaModelo={isFromVagaModelo}
                    title={
                      <FormattedMessage
                        id="step2.periodoInscricao"
                        defaultMessage="Período de Inscrição *"
                      />
                    }
                    isEditing={isEditingPeriodoInscricao}
                    setIsEditing={setIsEditingPeriodoInscricao}
                    isLocked={formState.isPeriodoInscricaoLocked}
                    setIsLocked={(v) =>
                      setFormState({ isPeriodoInscricaoLocked: v })
                    }
                    isVagaModelo={isVagaModelo}
                    isLockNotAllowed={
                      !formState.dataInicio || !formState.dataFim
                    }
                    isInvalid={!formState.dataInicio || !formState.dataFim}
                    dataTestIdBtn="editar-periodo"
                    dataTestIdLock="bloquear-periodo"
                  />
                  <Space />
                  {isEditingPeriodoInscricao ? (
                    <>
                      <div className={dateWrapper}>
                        <Input
                          type="date"
                          label={
                            <FormattedMessage
                              id="step2.inicio"
                              defaultMessage="Data de início"
                            />
                          }
                          variant="inline"
                          required
                          data-testid="input-data-inicio"
                          value={formState.dataInicio}
                          onChange={(e) =>
                            setFormState({
                              dataInicio: e.target.value,
                            })
                          }
                          errorMessage={
                            <FormattedMessage
                              id="step2.erroData"
                              defaultMessage="Data inválida"
                            />
                          }
                        ></Input>

                        <Space height=".5rem" />
                        <Input
                          type="date"
                          label={
                            <FormattedMessage
                              id="step2.fim"
                              defaultMessage="Data final"
                              description="Fim do período de inscrições"
                            />
                          }
                          variant="inline"
                          required
                          data-testid="input-data-fim"
                          value={formState.dataFim}
                          onChange={(e) =>
                            setFormState({
                              dataFim: e.target.value,
                            })
                          }
                          errorMessage={
                            <FormattedMessage
                              id="step2.erroData"
                              defaultMessage="Data inválida"
                            />
                          }
                        ></Input>
                      </div>
                      <Space height=".5rem" />

                      <Checkbox
                        label={
                          <FormattedMessage
                            id="step2.interromperInscricoes"
                            defaultMessage="Interromper inscrições (suspender vaga)"
                          />
                        }
                        checked={formState.isSuspenderVaga}
                        onChange={(e) =>
                          setFormState({ isSuspenderVaga: e.target.checked })
                        }
                        data-testid="checkbox-interromper-inscricoes"
                      />
                    </>
                  ) : (
                    <>
                      <div className={rowStyle}>
                        <IconeCalender
                          width={20}
                          height={18}
                          fill={vars.color.foreground}
                        />
                        <Text size="sm" as="p">
                          <FormattedMessage
                            id="step4.periodoInscricaoInicio"
                            defaultMessage="De"
                            description="referente a data. Exemplo: De 10/11 a 15/11"
                          />{" "}
                          {formState.dataInicio?.split("-").reverse().join("/")}{" "}
                          <FormattedMessage
                            id="step4.periodoInscricaoFim"
                            defaultMessage="a"
                            description="referente a data. Exemplo: De 10/11 a 15/11"
                          />{" "}
                          {formState.dataFim?.split("-").reverse().join("/")}
                        </Text>
                      </div>
                    </>
                  )}
                  {formState.isSuspenderVaga ? (
                    <>
                      <Space />
                      <Text size="sm" as="p">
                        <FormattedMessage
                          id="ste4.vagaSuspensa"
                          defaultMessage="Vaga suspensa"
                        />
                      </Text>
                    </>
                  ) : null}
                </>
              ) : null}

              {!isVagaModelo ? (
                <>
                  <div className={separatorStyle}></div>
                  <EditLock
                    isFromVagaModelo={isFromVagaModelo}
                    title={
                      <FormattedMessage
                        id="step3.divisao"
                        defaultMessage="Divisão *"
                      />
                    }
                    isEditing={isEditingDivisao}
                    setIsEditing={setIsEditingDivisao}
                    invalid={!formState.divisaoSelectedId}
                    dataTestIdBtn="editar-divisao"
                    dataTestIdLock="bloquear-divisao"
                  />

                  <Space height=".5rem" />

                  {isEditingDivisao ? (
                    <>
                      {formState.isAnuncioConfidencial ? (
                        <Alert>
                          <div className={infoIconContainer}>
                            <InfoIcon width={20} height={20} />
                          </div>
                          <Text size="sm" as="p">
                            <FormattedMessage
                              id="step1.infoVagaConfidencial"
                              defaultMessage="Esta vaga é confidencial. Divisões de recrutamento
                interno não serão exibidas no campo <strong>Divisão</strong>"
                              values={{
                                strong: (chunks) => <strong>{chunks}</strong>,
                              }}
                            />
                          </Text>
                        </Alert>
                      ) : null}
                      <Select
                        value={formState.divisaoSelectedId}
                        onChange={(e) =>
                          setFormState({
                            divisaoSelectedId: Number(e.target.value),
                          })
                        }
                        required
                        shouldValidate={hasTriedToSubmit}
                        errorMessage={
                          <FormattedMessage
                            id="erro.campoObrigatorio"
                            defaultMessage="Campo obrigatório"
                          />
                        }
                        data-testid="select-divisao"
                      >
                        {renderSelectOptions({
                          data: formState.divisaoData,
                          error: formState.divisaoError,
                          errorMessage: intl.formatMessage(
                            defineMessage({
                              id: "select.erro",
                              defaultMessage: "Ocorreu um erro",
                            })
                          ),
                          loadingMessage: intl.formatMessage(
                            defineMessage({
                              id: "select.loading",
                              defaultMessage: "Carregando...",
                            })
                          ),
                          selectOptionMessage: intl.formatMessage(
                            defineMessage({
                              id: "select.escolherOpcao",
                              defaultMessage: "Selecione uma opção...",
                            })
                          ),
                        })}
                      </Select>
                    </>
                  ) : (
                    <>
                      <Text size="sm" as="p">
                        {
                          formState.divisaoData?.find(
                            (v) => v.id == formState.divisaoSelectedId
                          )?.label
                        }
                      </Text>
                      {/* <div className={separatorStyle}></div> */}
                    </>
                  )}
                </>
              ) : null}

              {!isVagaModelo ? (
                <>
                  <div className={separatorStyle}></div>
                  <EditLock
                    isFromVagaModelo={isFromVagaModelo}
                    title={
                      <FormattedMessage
                        id="step3.titleAcessoRestrito"
                        defaultMessage="Acesso restrito (vaga-teste)"
                      />
                    }
                    isEditing={isEditingVagaTeste}
                    setIsEditing={setIsEditingVagaTeste}
                    dataTestIdBtn="editar-acesso-restrito"
                    dataTestIdLock="bloquear-acesso-restrito"
                    invalid={!formState.isVagaTeste && formState.senhaVagaTeste}
                  />

                  {isEditingVagaTeste ? (
                    <>
                      <Space height=".5rem" />
                      <Checkbox
                        label={
                          <FormattedMessage
                            id="step3.checkboxVagaRestrita"
                            defaultMessage="Deixar esta vaga restrita"
                          />
                        }
                        checked={formState.isVagaTeste}
                        onChange={(e) => {
                          if (!e.target.checked) {
                            setFormState({
                              senhaVagaTeste: "",
                            });
                          }
                          setFormState({ isVagaTeste: e.target.checked });
                        }}
                        data-testid="checkbox-vaga-teste"
                      />
                      <Space height=".5rem" />
                      <Input
                        label={
                          <FormattedMessage
                            id="step3.senha"
                            defaultMessage="Senha (opcional)"
                          />
                        }
                        placeholder={intl.formatMessage(
                          defineMessage({
                            id: "step1.placeholderSenha",
                            defaultMessage:
                              "Insira uma senha para acessar a vaga.",
                          })
                        )}
                        data-testid="input-senha"
                        type="text"
                        value={formState.senhaVagaTeste}
                        onChange={(e) =>
                          setFormState({ senhaVagaTeste: e.target.value })
                        }
                      />
                    </>
                  ) : (
                    <>
                      <Space height=".5rem" />
                      {formState.isVagaTeste ? (
                        <Text as="p" size="sm">
                          <FormattedMessage
                            id="radioButton.Sim"
                            defaultMessage="Sim"
                          />
                        </Text>
                      ) : (
                        <Text as="p" size="sm">
                          <FormattedMessage
                            id="radioButton.Nao"
                            defaultMessage="Não"
                          />
                        </Text>
                      )}
                    </>
                  )}
                </>
              ) : null}

              {!formState.isVagaTeste ? (
                <>
                  <div className={separatorStyle}></div>
                  <EditLock
                    isFromVagaModelo={isFromVagaModelo}
                    title={
                      <FormattedMessage
                        id="step3.titleCanaisDivulgacao"
                        defaultMessage="Canais de divulgação"
                      />
                    }
                    isEditing={isEditingCanaisDivulgacao}
                    setIsEditing={setIsEditingCanaisDivulgacao}
                    isLocked={formState.isCanaisDivulgacaoLocked}
                    setIsLocked={(v) =>
                      setFormState({ isCanaisDivulgacaoLocked: v })
                    }
                    isVagaModelo={isVagaModelo}
                    dataTestIdBtn="editar-canais-divulgacao"
                    dataTestIdLock="bloquear-canais-divulgacao"
                  />

                  <Space height=".5rem" />
                  {isEditingCanaisDivulgacao ? (
                    <>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "50% 50%",
                        }}
                      >
                        {formState.canaisDivulgacaoData?.map((canal) => (
                          <div key={`${canal.id}-${canal.label}`}>
                            <Checkbox
                              label={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={canal.imagem}
                                    alt={`logotipo ${canal.label}`}
                                    width="50px"
                                    height="40px"
                                  ></img>
                                  <Space />
                                  {canal.label}
                                </div>
                              }
                              checked={
                                formState.canaisDivulgacaoSelected?.find(
                                  (item) => item.id === canal.id
                                ) ?? false
                              }
                              onChange={(e) => {
                                setFormState({
                                  canaisDivulgacaoSelected: e.target.checked
                                    ? [
                                        ...formState.canaisDivulgacaoSelected,
                                        canal,
                                      ]
                                    : formState.canaisDivulgacaoSelected?.filter(
                                        (item) => item.id !== canal.id
                                      ),
                                });
                              }}
                              aria-label={`selecionar ${canal.label}`}
                            />
                            <Space height="1rem" />
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {formState.canaisDivulgacaoSelected
                        .filter((v) => v.id)
                        .map((v) => {
                          const canaisDivulgacao = {
                            ...v,
                            ...formState.canaisDivulgacaoData?.find(
                              (c) => c.id == c.canaisDivulgacaoSelected
                            ),
                          };
                          return (
                            <React.Fragment key={v.id}>
                              <div>
                                <img
                                  src={canaisDivulgacao.imagem}
                                  alt={`logotipo ${canaisDivulgacao.label}`}
                                  width="50px"
                                  height="40px"
                                ></img>
                              </div>
                              <Space width="1rem" />
                            </React.Fragment>
                          );
                        })}
                    </div>
                  )}
                </>
              ) : null}

              {isVagaModelo ? (
                <>
                  <div className={separatorStyle}></div>
                  <EditLock
                    isFromVagaModelo={isFromVagaModelo}
                    title={
                      <FormattedMessage
                        id="step3.divisoesAcesso"
                        defaultMessage="Divisões com acesso *"
                      />
                    }
                    isEditing={isEditingDivisaoAcesso}
                    setIsEditing={setIsEditingDivisaoAcesso}
                    isLocked={formState.isDivisaoAcessoLocked}
                    setIsLocked={(v) =>
                      setFormState({ isDivisaoAcessoLocked: v })
                    }
                    isVagaModelo={isVagaModelo}
                    isLockNotAllowed={!formState.divisoesAcessoSelected?.length}
                    hidden={true}
                    invalid={!formState.divisoesAcessoSelected?.length}
                    dataTestIdBtn="editar-divisoes-acesso"
                    dataTestIdLock="bloquear-divisoes-acesso"
                  />

                  <Space height=".5rem" />
                  {isEditingDivisaoAcesso ? (
                    <Multi
                      name="divisoesComAcesso"
                      options={formState.divisoesAcessoData}
                      required
                      state={formState.divisoesAcessoSelected}
                      onChange={(v) => {
                        setFormState({ divisoesAcessoSelected: v });
                      }}
                      getOptionValue={(option) => option.id}
                      noOptionsMessage={() => {
                        return formState.divisoesAcessoError ? (
                          <FormattedMessage
                            id="mensagem.ocorreuErro"
                            defaultMessage="Ocorreu um erro"
                          />
                        ) : (
                          <FormattedMessage
                            id="step1-limiteOpcoes"
                            defaultMessage="Não há mais opções disponíveis."
                          />
                        );
                      }}
                      placeholder={
                        <Text size="sm" fontColor={vars.color.lightForeground}>
                          <FormattedMessage
                            id="placeholder.pesquiseSelecione"
                            defaultMessage="Pesquise e selecione"
                          />
                        </Text>
                      }
                      errorMessage={
                        <FormattedMessage
                          id="erro.campoObrigatorio"
                          defaultMessage="Campo obrigatório"
                        />
                      }
                      shouldValidate={hasTriedToSubmit}
                      data-testid="select-divisoes-acesso"
                    ></Multi>
                  ) : (
                    <>
                      {formState.divisoesAcessoSelected
                        .filter((v) => v.id)
                        .map((v) => {
                          const divisoesAcesso = {
                            ...v,
                            ...formState.divisaoData?.find(
                              (c) => c.id == c.divisoesAcessoSelected
                            ),
                          };
                          return (
                            <div key={v.id}>
                              <Text size="sm" as="p">
                                {divisoesAcesso.label}
                              </Text>
                            </div>
                          );
                        })}
                    </>
                  )}
                </>
              ) : null}
            </FormCard>

            <div className={formButtonsWrapper}>
              <Button
                id="btn-publicar"
                className={`${primaryButton} ${inputVariants["form-buttons"]}`}
                type="submit"
                onClick={() => setHasTriedToSubmit(true)}
                data-testid="btn-continuar"
                disabled={
                  isPostPending || isVagaModelo
                    ? isSubmitVagaModeloDisabled
                    : isSubmitVagaDisabled
                }
                id="salvar-vaga"
              >
                {isPostPending ? (
                  <Spinner colorVariant="light" />
                ) : isEditingVaga ? (
                  <FormattedMessage
                    id="botao.salvarAlteracoes"
                    defaultMessage="Salvar alterações"
                  />
                ) : (
                  <FormattedMessage
                    id="botao.publicar"
                    defaultMessage="Publicar processo seletivo"
                  />
                )}
              </Button>
            </div>
          </form>
          <Toaster toasts={toasts} />
        </>
      )}
    </div>
  );
}
